webpackJsonp([1],Array(19).concat([
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var helper = {
  ytRegex: /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{10,12})(?:[&?#].*?)*?(?:[&?#]start|t=(\d+|[\dhm]+s))?$/,
  lihkgRegex: /^(?:https?:\/\/)?lihkg\.com\/(?:t|thread)\/(\d+)/,
  isIOS: function isIOS() {
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    );
  },
  trackEvent: function trackEvent(_ref) {
    var eventCategory = _ref.eventCategory,
        eventAction = _ref.eventAction,
        eventLabel = _ref.eventLabel;

    if (window.ga) {
      window.ga('send', 'event', eventCategory, eventAction, eventLabel);
    }
  },
  initYoutube: function initYoutube() {
    if (!window.YT) {
      var tag = document.createElement('script');
      var firstScriptTag = document.getElementsByTagName('script')[0];
      tag.src = 'https://www.youtube.com/iframe_api';
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  },
  elementInViewport: function elementInViewport(el) {
    var top = el.offsetTop;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
    }

    return top >= window.pageYOffset;
  },
  isOverflown: function isOverflown(element) {
    return element.scrollWidth > element.clientWidth;
  },
  getRelativeTime: function getRelativeTime(timestamp) {
    var current = Math.floor(Date.now() / 1000);
    var secondPerMinute = 60;
    var secondPerHour = secondPerMinute * 60;
    var secondPerDay = secondPerHour * 24;
    var secondPerMonth = secondPerDay * 30;
    var secondPerYear = secondPerDay * 365;

    var elapsed = current - timestamp;

    if (elapsed < secondPerMinute) {
      return '剛剛';
    } else if (elapsed < secondPerHour) {
      return Math.round(elapsed / secondPerMinute) + ' \u5206\u9418\u524D';
    } else if (elapsed < secondPerDay) {
      return Math.round(elapsed / secondPerHour) + ' \u5C0F\u6642\u524D';
    } else if (elapsed < secondPerMonth) {
      return Math.round(elapsed / secondPerDay) + ' \u65E5\u524D';
    } else if (elapsed < secondPerYear) {
      return Math.round(elapsed / secondPerMonth) + ' \u500B\u6708\u524D';
    }

    return Math.round(elapsed / secondPerYear) + ' \u5E74\u524D';
  },
  getConvertedTime: function getConvertedTime(timestamp) {
    var date = new Date(timestamp * 1000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hours = ('0' + date.getHours()).substr(-2);
    var minutes = ('0' + date.getMinutes()).substr(-2);
    var seconds = ('0' + date.getSeconds()).substr(-2);

    return year + '\u5E74' + month + '\u6708' + day + '\u65E5 ' + hours + ':' + minutes + ':' + seconds;
  },
  parseDuration: function parseDuration(duration) {
    var matches = duration.match(/[0-9]+[hms]/g);
    var seconds = 0;

    if (!matches) {
      return duration;
    }

    matches.forEach(function (part) {
      var unit = part.charAt(part.length - 1);
      var amount = parseInt(part.slice(0, -1), 10);

      switch (unit) {
        case 'h':
          seconds += amount * 60 * 60;
          break;
        case 'm':
          seconds += amount * 60;
          break;
        case 's':
          seconds += amount;
          break;
        default:
        // noop
      }
    });

    return seconds;
  },
  uniqBy: function uniqBy(originalArray, objKey) {
    var trimmedArray = [];
    var values = [];
    var value = void 0;

    for (var i = 0; i < originalArray.length; i += 1) {
      value = originalArray[i][objKey];

      if (values.indexOf(value) === -1) {
        trimmedArray.push(originalArray[i]);
        values.push(value);
      }
    }

    return trimmedArray;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (helper);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SYNC_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SYNC_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_ICON_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return UPDATE_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TOGGLE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_IS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_IS_HOVERABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REMOVE_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TOGGLE_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPEN_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIDE_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return TOGGLE_SETTINGS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TOGGLE_GALLERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIDE_GALLERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_FIXED_CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_THREAD_LIST_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_THREAD_LIST_IS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_THREAD_LIST_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_THREAD_LIST_HAS_MORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_THREAD_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APPEND_THREAD_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_STORY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_THREAD_IS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_THREAD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_THREAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APPEND_THREAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_IS_FETCHING_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_MEDIA_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_MEDIA_INDEX; });
// app related
var SYNC_HISTORY = 'SYNC_HISTORY';
var SYNC_SETTINGS = 'SYNC_SETTINGS';
var SET_ICON_MAP = 'SET_ICON_MAP';
var SET_HISTORY = 'SET_HISTORY';
var UPDATE_HISTORY = 'UPDATE_HISTORY';
var CLEAR_HISTORY = 'CLEAR_HISTORY';
var TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';
var SET_IS_MOBILE = 'SET_IS_MOBILE';
var SET_IS_HOVERABLE = 'SET_IS_HOVERABLE';
var ADD_BOOKMARK = 'ADD_BOOKMARK';
var REMOVE_BOOKMARK = 'REMOVE_BOOKMARK';

// ui related
var TOGGLE_DRAWER = 'TOGGLE_DRAWER';
var OPEN_DRAWER = 'OPEN_DRAWER';
var HIDE_DRAWER = 'HIDE_DRAWER';
var TOGGLE_SETTINGS_MODAL = 'TOGGLE_SETTINGS_MODAL';
var TOGGLE_GALLERY = 'TOGGLE_GALLERY';
var HIDE_GALLERY = 'HIDE_GALLERY';

// category related
var SET_CATEGORY_LIST = 'SET_CATEGORY_LIST';
var SET_FIXED_CATEGORY_LIST = 'SET_FIXED_CATEGORY_LIST';
var SET_CATEGORY = 'SET_CATEGORY';

// thread list related
var SET_THREAD_LIST_TYPE = 'SET_THREAD_LIST_TYPE';
var SET_THREAD_LIST_IS_LOADING = 'SET_THREAD_LIST_IS_LOADING';
var SET_THREAD_LIST_PAGE = 'SET_THREAD_LIST_PAGE';
var SET_THREAD_LIST_HAS_MORE = 'SET_THREAD_LIST_HAS_MORE';
var SET_THREAD_LIST = 'SET_THREAD_LIST';
var APPEND_THREAD_LIST = 'APPEND_THREAD_LIST';

// thread related
var SET_STORY_MODE = 'SET_STORY_MODE';
var SET_THREAD_IS_LOADING = 'SET_THREAD_IS_LOADING';
var SET_THREAD_PAGE = 'SET_THREAD_PAGE';
var SET_THREAD = 'SET_THREAD';
var APPEND_THREAD = 'APPEND_THREAD';
var SET_IS_FETCHING_MEDIA = 'SET_IS_FETCHING_MEDIA';
var SET_MEDIA_LIST = 'SET_MEDIA_LIST';
var SET_MEDIA_INDEX = 'SET_MEDIA_INDEX';

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);







var _this = this;

var API_ROOT = 'https://lihkg.com/api_v2';

var serialize = function serialize(obj) {
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    return key + '=' + obj[key];
  }).join('&');
};

var request = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(endpoint, params) {
    var serializedParams, response, json;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            serializedParams = params ? '?' + serialize(params) : '';
            _context.prev = 1;
            _context.next = 4;
            return fetch('' + API_ROOT + endpoint + serializedParams);

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;

            if (!json.success) {
              _context.next = 10;
              break;
            }

            return _context.abrupt('return', json);

          case 10:
            throw json;

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](1);

            console.log(_context.t0);
            throw _context.t0;

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 13]]);
  }));

  return function request(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchSystemProperty: function fetchSystemProperty() {
    return request('/system/property');
  },
  fetchThreadList: function fetchThreadList(_ref2) {
    var cat_id = _ref2.catId,
        _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page,
        _ref2$count = _ref2.count,
        count = _ref2$count === undefined ? 50 : _ref2$count,
        query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['catId', 'page', 'count']);

    var types = {
      1: 'latest',
      2: 'hot',
      3: 'news'
    };
    var type = types[cat_id] || 'category';

    var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      cat_id: cat_id,
      page: page,
      count: count
    }, query);

    return request('/thread/' + type, params);
  },
  fetchThreadListByIds: function fetchThreadListByIds(_ref3) {
    var thread_ids = _ref3.threadIds;

    return request('/thread/', { thread_ids: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(thread_ids) });
  },
  fetchThread: function fetchThread(_ref4) {
    var threadId = _ref4.threadId,
        _ref4$page = _ref4.page,
        page = _ref4$page === undefined ? 1 : _ref4$page,
        _ref4$order = _ref4.order,
        order = _ref4$order === undefined ? 'reply_time' : _ref4$order;

    return request('/thread/' + threadId + '/page/' + page, { order: order });
  },
  fetchSearchResult: function fetchSearchResult(_ref5) {
    var q = _ref5.query,
        page = _ref5.page,
        _ref5$sort = _ref5.sort,
        sort = _ref5$sort === undefined ? 'score' : _ref5$sort,
        _ref5$count = _ref5.count,
        count = _ref5$count === undefined ? 30 : _ref5$count;

    return request('/thread/search', {
      q: q,
      page: page,
      sort: sort,
      count: count
    });
  },
  fetchMediaList: function fetchMediaList(_ref6) {
    var threadId = _ref6.threadId;

    return request('/thread/' + threadId + '/images');
  }
});

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navbar__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BottomBar__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Drawer__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CategoryMenu__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SettingsModal__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Gallery_Gallery__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Lightbox__ = __webpack_require__(542);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    var nightModeClass = this.nightMode ? 'night-mode' : '';
    var isMobileClass = this.isMobile ? 'is-mobile' : '';
    var isHoverableClass = this.isHoverable ? 'is-hoverable' : '';
    return {
      title: this.officeMode ? 'Google' : 'LIHKG',
      titleTemplate: this.officeMode ? null : '%s | LIHKG（非官方)',
      htmlAttrs: {
        class: nightModeClass + ' ' + isMobileClass + ' ' + isHoverableClass
      },
      meta: [{
        name: 'theme-color',
        content: this.nightMode ? '#1e1e1e' : '#ffffff'
      }],
      link: [this.officeMode ? {
        rel: 'shortcut icon',
        href: 'https://www.google.com.hk/images/branding/product/ico/googleg_lodp.ico'
      } : {}]
    };
  },

  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_2__components_Navbar__["a" /* default */],
    BottomBar: __WEBPACK_IMPORTED_MODULE_3__components_BottomBar__["a" /* default */],
    Drawer: __WEBPACK_IMPORTED_MODULE_4__components_Drawer__["a" /* default */],
    CategoryMenu: __WEBPACK_IMPORTED_MODULE_5__components_CategoryMenu__["a" /* default */],
    SettingsModal: __WEBPACK_IMPORTED_MODULE_6__components_SettingsModal__["a" /* default */],
    Gallery: __WEBPACK_IMPORTED_MODULE_7__components_Gallery_Gallery__["a" /* default */],
    Lightbox: __WEBPACK_IMPORTED_MODULE_8__components_Lightbox__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    isHoverable: function isHoverable(state) {
      return state.app.isHoverable;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    officeMode: function officeMode(state) {
      return state.app.officeMode;
    },
    nightMode: function nightMode(state) {
      return state.app.nightMode;
    },
    showSettingsModal: function showSettingsModal(state) {
      return state.ui.showSettingsModal;
    },
    mediaList: function mediaList(state) {
      return state.thread.mediaList;
    },
    mediaIndex: function mediaIndex(state) {
      return state.thread.mediaIndex;
    },
    showGallery: function showGallery(state) {
      return state.ui.showGallery;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    toggleSettingsModal: 'TOGGLE_SETTINGS_MODAL',
    setIsMobile: 'SET_IS_MOBILE',
    setIsHoverable: 'SET_IS_HOVERABLE',
    setMediaList: 'SET_MEDIA_LIST',
    setMediaIndex: 'SET_MEDIA_INDEX'
  }), {
    handleResize: function handleResize() {
      var isMobile = window.innerWidth < 768;
      var isHoverable = !window.matchMedia('(hover: none)').matches;

      if (isMobile && !this.isMobile) {
        this.setIsMobile(true);
      } else if (!isMobile && this.isMobile) {
        this.setIsMobile(false);
      }

      if (isHoverable && !this.isHoverable) {
        this.setIsHoverable(true);
      } else if (!isHoverable && this.isHoverable) {
        this.setIsHoverable(false);
      }
    }
  }),
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TopAppBar__ = __webpack_require__(511);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopAppBar: __WEBPACK_IMPORTED_MODULE_5__TopAppBar__["a" /* default */]
  },
  data: function data() {
    return {
      tempDisable: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    showDrawer: function showDrawer(state) {
      return state.ui.showDrawer;
    },
    category: function category(state) {
      return state.category.category;
    },
    thread: function thread(state) {
      return state.thread.thread;
    },
    threadListType: function threadListType(state) {
      return state.threadList.threadListType;
    },
    relatedCatId: function relatedCatId(state) {
      return state.thread.thread.cat_id || 1;
    },
    mediaList: function mediaList(state) {
      return state.thread.mediaList;
    },
    bookmarks: function bookmarks(state) {
      return state.app.bookmarks;
    }
  }), {
    inThreadView: function inThreadView() {
      return this.$route.name === 'ThreadView';
    },
    inCatView: function inCatView() {
      return this.$route.name === 'CategoryView';
    },
    isBookmarked: function isBookmarked() {
      return this.bookmarks.includes(this.thread.thread_id);
    },
    threadListTitle: function threadListTitle() {
      return this.threadListType === 'bookmarks' ? '名已留' : this.category.name || 'LIHKG';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchThreadList', 'fetchThreadListByIds', 'fetchMediaList']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    toggleDrawer: 'TOGGLE_DRAWER',
    toggleSettingsModal: 'TOGGLE_SETTINGS_MODAL',
    setThreadList: 'SET_THREAD_LIST',
    toggleGallery: 'TOGGLE_GALLERY',
    addBookmark: 'ADD_BOOKMARK',
    removeBookmark: 'REMOVE_BOOKMARK'
  }), {
    handleReloadClick: function handleReloadClick() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
                  eventCategory: 'Navbar',
                  eventAction: 'click',
                  eventLabel: 'F5'
                });
                _this.setThreadList([]);

                if (!(_this.threadListType === 'bookmarks')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return _this.fetchThreadListByIds({ threadIds: _this.bookmarks });

              case 5:
                _context.next = 10;
                break;

              case 7:
                if (!(_this.threadListType === 'category')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return _this.fetchThreadList({ catId: _this.category.cat_id });

              case 10:
                window.scrollTo(0, 0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleNavMenuClick: function handleNavMenuClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'Navbar',
        eventAction: 'click',
        eventLabel: 'Drawer'
      });
      this.toggleDrawer();
    },
    handleSettingsClick: function handleSettingsClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'Navbar',
        eventAction: 'click',
        eventLabel: 'Settings'
      });
      this.toggleSettingsModal();
    },
    handleBackClick: function handleBackClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'Navbar',
        eventAction: 'click',
        eventLabel: 'Back'
      });
      if (this.threadListType) {
        window.history.back();
      } else {
        this.$router.push('/category/' + this.relatedCatId);
      }
    },
    handleMediaModeClick: function handleMediaModeClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'Navbar',
        eventAction: 'click',
        eventLabel: 'Media'
      });
      if (this.mediaList) {
        // if already fetched, show immediately and fetch update in the background
        this.toggleGallery();
        this.fetchMediaList({
          threadId: this.thread.thread_id,
          openGallery: false,
          showProgress: false
        });
      } else {
        this.fetchMediaList({
          threadId: this.thread.thread_id,
          openGallery: true
        });
      }
    },
    handleHotReplyClick: function handleHotReplyClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'Navbar',
        eventAction: 'click',
        eventLabel: 'Hot Reply'
      });
      if (this.$route.query.order === 'score') {
        this.$router.replace({ query: null });
      } else {
        this.$router.replace({ query: { order: 'score' } });
      }
    },
    handleBookmark: function handleBookmark() {
      if (this.isBookmarked) {
        this.removeBookmark(this.thread.thread_id);
      } else {
        this.addBookmark(this.thread.thread_id);
      }
    },
    scrollToTop: function scrollToTop() {
      var c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(this.scrollToTop);
        window.scrollTo(0, c - c / 8);
      }
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this2 = this;

      if (to.name === 'ThreadView' && from.name === 'CategoryView') {
        this.tempDisable = true;

        setTimeout(function () {
          _this2.tempDisable = false;
        }, 500);
      }
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    maxHeight: {
      type: Number,
      default: 64
    },
    zIndex: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      top: 0,
      lastScrollPosition: window ? window.scrollY : 0,
      topAppBarHeight: null,
      wasDocked: true,
      isDockedShowing: true,
      currentAppBarOffsetTop: 0,
      isCurrentlyBeingResized: false
    };
  },

  methods: {
    init: function init() {
      window.addEventListener('scroll', this.scrollHandler);
    },
    destroy: function destroy() {
      window.removeEventListener('scroll', this.scrollHandler);
      this.top = 0;
    },
    checkForUpdate: function checkForUpdate() {
      var offscreenBoundaryTop = -this.topAppBarHeight;
      var hasAnyPixelsOffscreen = this.currentAppBarOffsetTop < 0;
      var hasAnyPixelsOnscreen = this.currentAppBarOffsetTop > offscreenBoundaryTop;
      var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;

      if (partiallyShowing) {
        this.wasDocked = false;
      } else {
        if (!this.wasDocked) {
          this.wasDocked = true;
          return true;
        } else if (this.isDockedShowing !== hasAnyPixelsOnscreen) {
          this.isDockedShowing = hasAnyPixelsOnscreen;
          return true;
        }
      }

      return partiallyShowing;
    },
    moveTopAppBar: function moveTopAppBar() {
      if (this.checkForUpdate()) {
        var offset = this.currentAppBarOffsetTop;
        if (Math.abs(offset) >= this.topAppBarHeight) {
          offset = -this.maxHeight;
        }

        this.top = offset;
      }
    },
    scrollHandler: function scrollHandler() {
      var currentScrollPosition = Math.max(window.scrollY, 0);
      var diff = currentScrollPosition - this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;

      if (!this.isCurrentlyBeingResized) {
        this.currentAppBarOffsetTop -= diff;

        if (this.currentAppBarOffsetTop > 0) {
          this.currentAppBarOffsetTop = 0;
        } else if (Math.abs(this.currentAppBarOffsetTop) > this.topAppBarHeight) {
          this.currentAppBarOffsetTop = -this.topAppBarHeight;
        }

        this.moveTopAppBar();
      }
    }
  },
  watch: {
    disabled: function disabled(_disabled) {
      if (_disabled) {
        this.destroy();
      } else {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    this.topAppBarHeight = this.$refs.appBar.clientHeight;
    if (!this.disabled) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.disabled) {
      this.destroy();
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(19);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    thread: function thread(state) {
      return state.thread.thread;
    },
    category: function category(state) {
      return state.category.category;
    },
    threadListType: function threadListType(state) {
      return state.threadList.threadListType;
    },
    mediaList: function mediaList(state) {
      return state.thread.mediaList;
    },
    bookmarks: function bookmarks(state) {
      return state.app.bookmarks;
    }
  }), {
    inThreadView: function inThreadView() {
      return this.$route.name === 'ThreadView';
    },
    inCatView: function inCatView() {
      return this.$route.name === 'CategoryView';
    },
    isBookmarked: function isBookmarked() {
      return this.bookmarks.includes(this.thread.thread_id);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchThreadList', 'fetchThreadListByIds', 'fetchMediaList']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    toggleDrawer: 'TOGGLE_DRAWER',
    toggleSettingsModal: 'TOGGLE_SETTINGS_MODAL',
    setThreadList: 'SET_THREAD_LIST',
    toggleGallery: 'TOGGLE_GALLERY',
    addBookmark: 'ADD_BOOKMARK',
    removeBookmark: 'REMOVE_BOOKMARK'
  }), {
    handleDrawerClick: function handleDrawerClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'BottomBar',
        eventAction: 'click',
        eventLabel: 'Drawer'
      });
      this.toggleDrawer();
    },
    handleReloadClick: function handleReloadClick() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
                  eventCategory: 'Navbar',
                  eventAction: 'click',
                  eventLabel: 'F5'
                });
                _this.setThreadList([]);

                if (!(_this.threadListType === 'bookmarks')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return _this.fetchThreadListByIds({ threadIds: _this.bookmarks });

              case 5:
                _context.next = 10;
                break;

              case 7:
                if (!(_this.threadListType === 'category')) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return _this.fetchThreadList({ catId: _this.category.cat_id });

              case 10:
                window.scrollTo(0, 0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSettingsClick: function handleSettingsClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'BottomBar',
        eventAction: 'click',
        eventLabel: 'Settings'
      });
      this.toggleSettingsModal();
    },
    handleScrollBottom: function handleScrollBottom() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'BottomBar',
        eventAction: 'click',
        eventLabel: 'Scroll to bottom'
      });
      window.scrollTo(0, document.body.scrollHeight);
    },
    handleMediaModeClick: function handleMediaModeClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'BottomBar',
        eventAction: 'click',
        eventLabel: 'Media'
      });
      if (this.mediaList) {
        // if already fetched, show immediately and fetch update in the background
        this.toggleGallery();
        this.fetchMediaList({
          threadId: this.thread.thread_id,
          openGallery: false,
          showProgress: false
        });
      } else {
        this.fetchMediaList({
          threadId: this.thread.thread_id,
          openGallery: true
        });
      }
    },
    handleHotReplyClick: function handleHotReplyClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'BottomBar',
        eventAction: 'click',
        eventLabel: 'Hot Reply'
      });
      if (this.$route.query.order === 'score') {
        this.$router.replace({ query: null });
      } else {
        this.$router.replace({ query: { order: 'score' } });
      }
    },
    handleBookmark: function handleBookmark() {
      if (this.isBookmarked) {
        this.removeBookmark(this.thread.thread_id);
      } else {
        this.addBookmark(this.thread.thread_id);
      }
    }
  })
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(19);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var DRAWER_WIDTH = 200;

function isInTag(node, tag) {
  var parent = node;
  while (parent.parentNode) {
    if (parent.nodeName.toLowerCase() === tag) {
      return true;
    }
    parent = parent.parentNode;
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      deltaX: 0,
      isPressed: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    fixedCategoryList: function fixedCategoryList(state) {
      return state.category.fixedCategoryList;
    },
    isOpen: function isOpen(state) {
      return state.ui.showDrawer;
    },
    activeCategoryId: function activeCategoryId(state) {
      return state.category.category.cat_id;
    },
    threadListType: function threadListType(state) {
      return state.threadList.threadListType;
    },
    isSwipeDisabled: function isSwipeDisabled(state) {
      return state.thread.mediaList !== null || state.thread.mediaIndex !== null;
    }
  }), {
    xPos: function xPos() {
      return this.isOpen ? Math.min(Math.max(this.deltaX, -DRAWER_WIDTH), 0) : Math.min(Math.max(this.deltaX, 0), DRAWER_WIDTH) - DRAWER_WIDTH;
    },
    opacity: function opacity() {
      return this.isOpen ? 1 : this.deltaX / DRAWER_WIDTH;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    openDrawer: 'OPEN_DRAWER',
    hideDrawer: 'HIDE_DRAWER',
    toggleSettingsModal: 'TOGGLE_SETTINGS_MODAL'
  }), {
    handleSettingsClick: function handleSettingsClick() {
      __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].trackEvent({
        eventCategory: 'Drawer',
        eventAction: 'click',
        eventLabel: 'Settings'
      });
      this.hideDrawer();
      this.toggleSettingsModal();
    },
    handleLinkClick: function handleLinkClick(event) {
      var _this = this;

      setTimeout(function () {
        _this.$router.push(event.target.pathname);
      }, 200);
      this.hideDrawer();
    },
    handleTouchStart: function handleTouchStart(event) {
      var isScrollingCode = event.target.tagName.toLowerCase() === 'pre' || isInTag(event.target, 'pre');
      // prevent overlap with iOS swipe back gesture
      var startDistance = __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].isIOS() ? 50 : 20;
      if (event.touches[0].pageX < startDistance || this.isSwipeDisabled || isScrollingCode) return;
      this.downX = event.touches[0].pageX;
      this.downY = event.touches[0].pageY;
      this.isPressed = true;
    },
    handleTouchMove: function handleTouchMove(event) {
      if (!this.isPressed) return;
      var inDrawer = this.$refs.drawer.contains(event.target);
      var deltaX = event.touches[0].pageX - this.downX;
      var deltaY = event.touches[0].pageY - this.downY;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);

      if (absX > 5 || absY > 5) {
        var willOpen = absX / absY > 2.5;
        this.direction = this.direction || (willOpen ? 'x' : 'y');

        if (this.direction === 'x' && (!this.isOpen && deltaX > 0 || this.isOpen && deltaX < 0)) {
          this.deltaX = deltaX;
        } else if (this.direction === 'y') {
          if (this.isOpen && !inDrawer) {
            event.preventDefault();
          }
        }
      }
    },
    handleTouchEnd: function handleTouchEnd() {
      if (this.deltaX > 60) {
        this.openDrawer();
        __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].trackEvent({
          eventCategory: 'Drawer',
          eventAction: 'swipe',
          eventLabel: 'Open'
        });
      } else if (this.deltaX < -40) {
        this.hideDrawer();
        __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].trackEvent({
          eventCategory: 'Drawer',
          eventAction: 'swipe',
          eventLabel: 'Close'
        });
      }
      this.isPressed = false;
      this.downX = null;
      this.direction = null;
      this.deltaX = 0;
    }
  }),
  mounted: function mounted() {
    window.addEventListener('touchstart', this.handleTouchStart);
    window.addEventListener('touchmove', this.handleTouchMove);
    window.addEventListener('touchend', this.handleTouchEnd);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('touchstart', this.handleTouchStart);
    window.removeEventListener('touchmove', this.handleTouchMove);
    window.removeEventListener('touchend', this.handleTouchEnd);
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    fixedCategoryList: function fixedCategoryList(state) {
      return state.category.fixedCategoryList;
    },
    showDrawer: function showDrawer(state) {
      return state.ui.showDrawer;
    },
    activeCategoryId: function activeCategoryId(state) {
      return state.category.category.cat_id;
    },
    threadListType: function threadListType(state) {
      return state.threadList.threadListType;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    hideDrawer: 'HIDE_DRAWER'
  }), {
    handleScroll: function handleScroll() {
      window.requestAnimationFrame(this.update);
    },
    handleLinkClick: function handleLinkClick(event) {
      var _this = this;

      setTimeout(function () {
        _this.$router.push(event.target.pathname);
      }, 400);
      this.hideDrawer();
    },
    update: function update() {
      var distanceScrolled = Math.abs(window.pageYOffset - this.lastKnownScrollY);
      if (distanceScrolled > 10 && this.showDrawer) {
        this.hideDrawer();
      }

      this.lastKnownScrollY = window.pageYOffset;
    }
  }),
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toggle__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActionButton__ = __webpack_require__(532);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */],
    Toggle: __WEBPACK_IMPORTED_MODULE_6__Toggle__["a" /* default */],
    ActionButton: __WEBPACK_IMPORTED_MODULE_7__ActionButton__["a" /* default */]
  },
  data: function data() {
    return {
      clearHistorySuccess: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    officeMode: function officeMode(state) {
      return state.app.officeMode;
    },
    staticIcons: function staticIcons(state) {
      return state.app.staticIcons;
    },
    autoLoadImage: function autoLoadImage(state) {
      return state.app.autoLoadImage;
    },
    nightMode: function nightMode(state) {
      return state.app.nightMode;
    },
    youtubePreview: function youtubePreview(state) {
      return state.app.youtubePreview;
    },
    imageProxy: function imageProxy(state) {
      return state.app.imageProxy;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['tryClearHistory']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    toggleSettings: 'TOGGLE_SETTINGS',
    clearHistory: 'CLEAR_HISTORY'
  }), {
    handleToggleClick: function handleToggleClick(key) {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'Settings',
        eventAction: 'click',
        eventLabel: key + ' ' + (this[key] ? 'OFF' : 'ON')
      });
      this.toggleSettings(key);
    },
    handleClearHistory: function handleClearHistory() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
                  eventCategory: 'Settings',
                  eventAction: 'click',
                  eventLabel: 'Clear History'
                });
                try {
                  _this.clearHistory();
                  _this.clearHistorySuccess = true;
                  setTimeout(function () {
                    _this.clearHistorySuccess = false;
                  }, 2000);
                } catch (error) {
                  console.log(error);
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    handleKeyDown: function handleKeyDown(event) {
      if (event.keyCode === 27) {
        this.$emit('close');
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['on'],
  data: function data() {
    return {
      id: '' + Date.now() + Math.round(Math.random() * 10000)
    };
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['success']
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Media__ = __webpack_require__(538);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['mediaList'],
  components: {
    Media: __WEBPACK_IMPORTED_MODULE_2__Media__["a" /* default */]
  },
  data: function data() {
    return {
      isListened: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    mediaIndex: function mediaIndex(state) {
      return state.thread.mediaIndex;
    },
    imageProxy: function imageProxy(state) {
      return state.app.imageProxy;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    toggleGallery: 'TOGGLE_GALLERY',
    setMediaIndex: 'SET_MEDIA_INDEX'
  }), {
    onBeforeEnter: function onBeforeEnter() {
      this.scrollPos = window.pageYOffset;
    },
    onAfterEnter: function onAfterEnter() {
      this.$nextTick(function () {
        document.getElementById('route-container').style.display = 'none';
      });
    },
    onBeforeLeave: function onBeforeLeave() {
      document.getElementById('route-container').style.display = null;
      window.scrollTo(0, this.scrollPos);
    },
    handleCloseClick: function handleCloseClick() {
      this.toggleGallery();
    },
    handleMediaClick: function handleMediaClick(index) {
      this.setMediaIndex(index);
    },
    handleKeyDown: function handleKeyDown(event) {
      if (event.keyCode === 27) {
        this.handleCloseClick();
      }
    },
    handleAddKeyListener: function handleAddKeyListener() {
      window.addEventListener('keydown', this.handleKeyDown);
      this.isListened = true;
    },
    handleRemoveKeyListener: function handleRemoveKeyListener() {
      window.removeEventListener('keydown', this.handleKeyDown);
      this.isListened = false;
    }
  }),
  watch: {
    mediaIndex: function mediaIndex(index) {
      if (index !== null && this.isListened) {
        this.handleRemoveKeyListener();
      } else if (index === null && !this.isListened) {
        this.handleAddKeyListener();
      }
    }
  },
  mounted: function mounted() {
    this.handleAddKeyListener();
  },
  beforeDestroy: function beforeDestroy() {
    this.handleRemoveKeyListener();
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['media'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    imageProxy: function imageProxy(state) {
      return state.app.imageProxy;
    }
  }), {
    src: function src() {
      return this.imageProxy ? 'https://i.lihkg.com/200/' + this.media.url : this.media.url;
    }
  })
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['mediaIndex'],
  data: function data() {
    return {
      transitionName: 'next',
      imageLoaded: false,
      imageError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    mediaList: function mediaList(state) {
      return state.thread.mediaList;
    }
  }), {
    media: function media() {
      return this.mediaList[this.mediaIndex];
    },
    hasPrev: function hasPrev() {
      return this.mediaIndex > 0;
    },
    hasNext: function hasNext() {
      return this.mediaIndex + 1 !== this.mediaList.length;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setMediaIndex: 'SET_MEDIA_INDEX'
  }), {
    handleCloseClick: function handleCloseClick() {
      this.setMediaIndex(null);
    },
    handleKeyDown: function handleKeyDown(event) {
      switch (event.keyCode) {
        case 27:
        case 40:
          event.preventDefault();
          this.handleCloseClick();
          break;
        case 37:
          if (!this.hasPrev) return;
          this.handleNavigation(-1);
          break;
        case 39:
          if (!this.hasNext) return;
          this.handleNavigation(1);
          break;
        default:
      }
    },
    handleNavigation: function handleNavigation(step) {
      this.setMediaIndex(this.mediaIndex + step);
    }
  }),
  watch: {
    mediaIndex: function mediaIndex(newVal, oldVal) {
      this.imageLoaded = false;
      this.imageError = false;
      this.transitionName = newVal < oldVal ? 'prev' : 'next';
    }
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ThreadList_ThreadList__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SubCategorySwitcher__ = __webpack_require__(560);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['catId'],
  components: {
    ThreadList: __WEBPACK_IMPORTED_MODULE_3__components_ThreadList_ThreadList__["a" /* default */],
    SubCategorySwitcher: __WEBPACK_IMPORTED_MODULE_4__components_SubCategorySwitcher__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: this.officeMode ? 'Google' : this.category.name || 'LIHKG'
    };
  },
  data: function data() {
    return {
      canLoadMore: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    officeMode: function officeMode(state) {
      return state.app.officeMode;
    },
    category: function category(state) {
      return state.category.category;
    },
    categoryList: function categoryList(state) {
      return state.category.categoryList;
    },
    threadList: function threadList(state) {
      return state.threadList.threadList;
    },
    threadListType: function threadListType(state) {
      return state.threadList.threadListType;
    },
    page: function page(state) {
      return state.threadList.page;
    },
    isLoading: function isLoading(state) {
      return state.threadList.isLoading;
    },
    activeThreadId: function activeThreadId(state) {
      return state.thread.thread.thread_id;
    }
  }), {
    subCategoryList: function subCategoryList() {
      var _this = this;

      var category = this.categoryList.find(function (cat) {
        return +cat.cat_id === +_this.catId;
      });
      return category ? category.sub_category : [];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchThreadList']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setThreadList: 'SET_THREAD_LIST',
    setThreadListType: 'SET_THREAD_LIST_TYPE'
  }), {
    fetchAndScrollTop: function fetchAndScrollTop() {
      this.setThreadList([]);
      window.scrollTo(0, 0);
      this.fetchThreadList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        catId: this.catId
      }, this.$route.query));
    },
    handleLoadMore: function handleLoadMore() {
      if (this.canLoadMore) {
        this.fetchNextPage();
      }
    },
    fetchNextPage: function fetchNextPage() {
      this.fetchThreadList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        catId: this.catId,
        page: this.page + 1
      }, this.$route.query));
    }
  }),
  watch: {
    catId: 'fetchAndScrollTop',
    '$route.query': 'fetchAndScrollTop',
    threadListType: function threadListType(newVal, oldVal) {
      if (oldVal !== newVal && newVal === 'category') {
        // this.fetchAndScrollTop()
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.setThreadListType('category');

    setTimeout(function () {
      _this2.canLoadMore = true;
    }, 200);

    if (this.activeThreadId) {
      var threadItem = document.getElementById(this.activeThreadId);
      if (threadItem) {
        threadItem.classList.add('highlight');
        setTimeout(function () {
          threadItem.classList.remove('highlight');
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadList_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec967b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(550)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ec967b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec967b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec967b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThreadListItem__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Placeholder__ = __webpack_require__(556);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var placeholderHeight = 80;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['threadList', 'isLoading'],
  components: {
    ThreadListItem: __WEBPACK_IMPORTED_MODULE_2__ThreadListItem__["a" /* default */],
    Placeholder: __WEBPACK_IMPORTED_MODULE_3__Placeholder__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    history: function history(state) {
      return state.app.history;
    },
    hasMore: function hasMore(state) {
      return state.threadList.hasMore;
    }
  }), {
    numberOfPlaceholder: function numberOfPlaceholder() {
      return Math.ceil(window.screen.height / placeholderHeight);
    }
  }),
  methods: {
    onEndReached: function onEndReached(isVisible) {
      if (this.isLoading) return;
      if (!isVisible) return;
      this.$emit('load-more');
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PTag__ = __webpack_require__(214);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['thread', 'isVisited', 'lastReadPage', 'lastReadPostId', 'newReply'],
  components: {
    PTag: __WEBPACK_IMPORTED_MODULE_3__PTag__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    bookmarks: function bookmarks(state) {
      return state.app.bookmarks;
    }
  }), {
    routeObj: function routeObj() {
      return {
        name: 'ThreadView',
        params: {
          threadId: this.thread.thread_id,
          page: this.lastReadPage || 1
        },
        query: this.lastReadPostId ? {
          post: this.lastReadPostId
        } : {}
      };
    },
    score: function score() {
      return this.thread.like_count - this.thread.dislike_count;
    },
    lastReplyTime: function lastReplyTime() {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].getRelativeTime(this.thread.last_reply_time);
    },
    hasUnread: function hasUnread() {
      return this.newReply > 0;
    },
    isBookmarked: function isBookmarked() {
      return this.bookmarks.includes(this.thread.thread_id);
    }
  }),
  methods: {
    handlePageSelectClick: function handlePageSelectClick() {
      return false;
    },
    handlePageSelect: function handlePageSelect(event) {
      this.$router.push('/thread/' + this.thread.thread_id + '/page/' + event.target.value);
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4feaeef7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PTag_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(553)
}
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4feaeef7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4feaeef7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PTag_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4feaeef7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PTag_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(19);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['list'],
  data: function data() {
    return {
      visibleItemsCount: this.list.length
    };
  },

  computed: {
    preparedList: function preparedList() {
      return this.list.map(function (item) {
        var _item$query = item.query,
            cat_id = _item$query.cat_id,
            query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_item$query, ['cat_id']);

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          query: query
        });
      });
    },
    activeSubCat: function activeSubCat() {
      var _this = this;

      return this.preparedList.filter(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default()(item.query, _this.$route.query);
      })[0];
    },
    activeSubCatIndex: function activeSubCatIndex() {
      return this.preparedList.indexOf(this.activeSubCat);
    },
    activeSubCatHidden: function activeSubCatHidden() {
      return this.activeSubCatIndex >= this.visibleItemsCount;
    }
  },
  methods: {
    renderVisibleItems: function renderVisibleItems() {
      var _this2 = this;

      this.visibleItemsCount = this.list.length;

      this.$nextTick(function () {
        if (!_this2.$refs.container) return;

        var isOverflown = __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].isOverflown(_this2.$refs.container);

        if (!isOverflown) return;

        var total = 0;
        var count = void 0;

        for (var index = 0; index < _this2.$refs.items.length; index++) {
          var item = _this2.$refs.items[index];
          total += item.clientWidth;
          if (total > _this2.$refs.container.clientWidth) {
            count = index - 1;
            break;
          }
        }

        _this2.visibleItemsCount = count;
      });
    },
    handleSubCatChange: function handleSubCatChange(event) {
      var subCatId = event.target.value;
      var item = this.preparedList.filter(function (item) {
        return +item.sub_cat_id === +subCatId;
      })[0];
      if (item) {
        this.$router.push({
          query: item.query
        });
      }
    },

    onResize: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      this.renderVisibleItems();
    }, 200)
  },
  watch: {
    list: {
      handler: 'renderVisibleItems',
      immediate: true
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
});

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Thread_Page__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Thread_ThreadNavigation__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Thread_NavigationPlaceholder__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Thread_PostPlaceholder__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loader__ = __webpack_require__(241);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return {
      title: this.officeMode ? 'Google' : this.thread.title || 'LIHKG'
    };
  },

  components: {
    Page: __WEBPACK_IMPORTED_MODULE_5__components_Thread_Page__["a" /* default */],
    ThreadNavigation: __WEBPACK_IMPORTED_MODULE_6__components_Thread_ThreadNavigation__["a" /* default */],
    NavigationPlaceholder: __WEBPACK_IMPORTED_MODULE_7__components_Thread_NavigationPlaceholder__["a" /* default */],
    PostPlaceholder: __WEBPACK_IMPORTED_MODULE_8__components_Thread_PostPlaceholder__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_9__components_Loader__["a" /* default */]
  },
  props: ['threadId', 'page'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    officeMode: function officeMode(state) {
      return state.app.officeMode;
    },
    thread: function thread(state) {
      return state.thread.thread;
    },
    isLoading: function isLoading(state) {
      return state.thread.isLoading;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['loadedPages', 'maxPage', 'minPage', 'hasNextPage'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchThread']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    setThread: 'SET_THREAD',
    updateHistory: 'UPDATE_HISTORY',
    setMediaList: 'SET_MEDIA_LIST',
    setMediaIndex: 'SET_MEDIA_INDEX',
    hideGallery: 'HIDE_GALLERY'
  }), {
    updateUrl: function updateUrl(page) {
      this.$router.replace({ params: { page: page }, query: this.$route.query });
    },
    onEndReached: function onEndReached(isVisible) {
      if (this.isLoading) return;
      if (!isVisible) return;

      if (this.hasNextPage) {
        this.fetchNextPage();
      } else {
        this.reload();
      }
    },
    tryFetchThread: function tryFetchThread(_ref) {
      var _this = this;

      var page = _ref.page,
          _ref$append = _ref.append,
          append = _ref$append === undefined ? false : _ref$append;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _this.fetchThread({
                  threadId: _this.threadId,
                  page: page,
                  append: append,
                  order: _this.$route.query.order
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchNextPage: function fetchNextPage() {
      this.tryFetchThread({
        page: this.maxPage + 1,
        append: true
      });
      this.updateUrl(this.maxPage + 1);
    },
    jumpToPage: function jumpToPage(page, retainScroll) {
      var pageNumber = Number(page) + Number(retainScroll);
      var offsetTop = retainScroll ? 180 : 120;
      var pageContainer = document.getElementById('page-' + pageNumber);

      if (pageContainer) {
        var top = pageContainer.offsetTop - offsetTop;
        window.scrollTo(0, top);
      }
    },
    fetchPage: function fetchPage(page) {
      var _this2 = this;

      var retainScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var append, isPageLoaded;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                append = +page === +_this2.maxPage + 1 || +page === +_this2.minPage - 1;
                isPageLoaded = page in _this2.thread.pages;

                if (isPageLoaded) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return _this2.tryFetchThread({
                  page: page,
                  append: append
                });

              case 5:
                _this2.updateUrl(page);
                _this2.jumpToPage(page, !isPageLoaded && retainScroll);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    reload: function reload() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.tryFetchThread({
                  page: _this3.page,
                  append: true
                });

              case 2:
                data = _context3.sent;

                if (data.response && data.response.total_page > _this3.maxPage) {
                  _this3.fetchNextPage();
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleReloadClick: function handleReloadClick() {
      __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].trackEvent({
        eventCategory: 'ThreadView',
        eventAction: 'click',
        eventLabel: 'F5'
      });
      this.reload();
    },
    getLastRead: function getLastRead() {
      var postId = void 0;
      var page = void 0;
      var posts = document.querySelectorAll('.post');
      for (var index = 0; index < posts.length; index += 1) {
        var post = posts[index];
        if (__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].elementInViewport(post)) {
          postId = post.getAttribute('data-id');
          page = post.getAttribute('data-page');
          break;
        }
      }
      return { postId: postId, page: page };
    },
    saveLastRead: function saveLastRead() {
      var _getLastRead = this.getLastRead(),
          postId = _getLastRead.postId,
          page = _getLastRead.page;

      this.updateHistory({
        threadId: this.threadId,
        postId: postId,
        page: page
      });
      return { postId: postId, page: page };
    },
    jumpToPost: function jumpToPost(postId) {
      var post = document.getElementById('post-' + postId);
      if (post) {
        window.scrollTo(0, post.offsetTop - 50);
      }
    }
  }),
  watch: {
    $route: function $route(to, from) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(to.query.order !== from.query.order)) {
                  _context4.next = 10;
                  break;
                }

                _this4.setThread({});

                if (!(to.query.order === 'score')) {
                  _context4.next = 7;
                  break;
                }

                _this4.lastRead = _this4.saveLastRead();
                _this4.fetchPage(1);
                _context4.next = 10;
                break;

              case 7:
                _context4.next = 9;
                return _this4.tryFetchThread({
                  page: _this4.lastRead ? _this4.lastRead.page : 1
                });

              case 9:
                if (_this4.lastRead && _this4.lastRead.postId) {
                  _this4.jumpToPost(_this4.lastRead.postId);
                }

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  },
  beforeMount: function beforeMount() {
    this.setThread({});
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var postId;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (_this5.thread.thread_id) {
                _context5.next = 5;
                break;
              }

              _context5.next = 3;
              return _this5.tryFetchThread({
                page: _this5.page
              });

            case 3:
              postId = _this5.$route.query.post;

              if (postId) {
                _this5.jumpToPost(postId);
              }

            case 5:

              window.onbeforeunload = function () {
                _this5.saveLastRead();
              };

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.setMediaList(null);
    this.setMediaIndex(null);
    this.hideGallery();
    if (this.$route.query.order !== 'score') {
      this.saveLastRead();
    }
    next();
  },
  beforeDestroy: function beforeDestroy() {
    window.onbeforeunload = null;
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Post__ = __webpack_require__(640);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__Post__["a" /* default */]
  },
  props: ['pageObj', 'pageNumber', 'threadId']
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PostQuote__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Message_Message__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PTag__ = __webpack_require__(214);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['post'],
  components: {
    PostQuote: __WEBPACK_IMPORTED_MODULE_3__PostQuote__["a" /* default */],
    Message: __WEBPACK_IMPORTED_MODULE_4__Message_Message__["a" /* default */],
    PTag: __WEBPACK_IMPORTED_MODULE_5__PTag__["a" /* default */]
  },
  data: function data() {
    return {
      tempVisible: false,
      showAbsoluteTime: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    storyMode: function storyMode(state) {
      return state.thread.storyMode;
    },
    authodId: function authodId(state) {
      return state.thread.thread.user_id;
    },
    threadLikeCount: function threadLikeCount(state) {
      return state.thread.thread.like_count;
    },
    threadDislikeCount: function threadDislikeCount(state) {
      return state.thread.thread.dislike_count;
    }
  }), {
    userId: function userId() {
      return this.post.user.user_id;
    },
    isAuthor: function isAuthor() {
      return +this.authodId === +this.userId;
    },
    likeCount: function likeCount() {
      return +this.post.msg_num === 1 ? this.threadLikeCount : this.post.like_count;
    },
    dislikeCount: function dislikeCount() {
      return +this.post.msg_num === 1 ? this.threadDislikeCount : this.post.dislike_count;
    },
    replyTime: function replyTime() {
      return {
        relative: __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].getRelativeTime(this.post.reply_time),
        absolute: __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].getConvertedTime(this.post.reply_time)
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setStoryMode: 'SET_STORY_MODE'
  }), {
    handleToggleStoryMode: function handleToggleStoryMode() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].trackEvent({
        eventCategory: 'ThreadView',
        eventAction: 'click',
        eventLabel: 'Story mode'
      });

      var _$refs$container$getB = this.$refs.container.getBoundingClientRect(),
          top = _$refs$container$getB.top;

      this.setStoryMode(this.storyMode ? null : this.userId);
      this.$nextTick(function () {
        window.scrollTo(0, _this.$refs.container.offsetTop - top);
      });
    }
  })
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostQuote_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f2c386_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostQuote_vue__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(642)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26f2c386"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostQuote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f2c386_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostQuote_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f2c386_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostQuote_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message_Message__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PostQuote__ = __webpack_require__(229);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PostQuote',
  props: ['quote', 'level'],
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_0__Message_Message__["a" /* default */],
    PostQuote: __WEBPACK_IMPORTED_MODULE_1__PostQuote__["a" /* default */]
  },
  data: function data() {
    return {
      hideChildren: true
    };
  },

  computed: {
    link: function link() {
      return '/thread/' + this.quote.thread_id + '/page/' + this.quote.page + '?post=' + this.quote.msg_num;
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify_lib_parse__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify_lib_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html_parse_stringify_lib_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_linkifyjs_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_entities_lib_decode__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_entities_lib_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_entities_lib_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Message__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Quote__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Member__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pic__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Anchor__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CodeBlock__ = __webpack_require__(687);

















function getInlineStyle(str) {
  return str.split(/\s{0,};\s{0,}/).map(function (s) {
    var _s$split = s.split(/\s{0,}:\s{0,}/),
        _s$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_s$split, 2),
        attr = _s$split2[0],
        value = _s$split2[1];

    return [attr.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    }), value];
  }).reduce(function (accum, prop) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, accum, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, prop[0], prop[1]));
  }, {});
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['html'],
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_7__Message__["a" /* default */],
    Quote: __WEBPACK_IMPORTED_MODULE_8__Quote__["a" /* default */],
    Member: __WEBPACK_IMPORTED_MODULE_9__Member__["a" /* default */],
    Pic: __WEBPACK_IMPORTED_MODULE_10__Pic__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_11__Icon__["a" /* default */],
    Anchor: __WEBPACK_IMPORTED_MODULE_12__Anchor__["a" /* default */],
    CodeBlock: __WEBPACK_IMPORTED_MODULE_13__CodeBlock__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    imageProxy: function imageProxy(state) {
      return state.app.imageProxy;
    }
  }), {
    parsedMessage: function parsedMessage() {
      var message = this.html;
      message = __WEBPACK_IMPORTED_MODULE_5_linkifyjs_html___default()(message, {
        ignoreTags: ['code'],
        validate: {
          email: function email() {
            return false;
          }
        }
      });
      message = message.replace(/src="\/assets/g, 'src="https://lihkg.com/assets');
      var ast = __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify_lib_parse___default()('<x>' + message + '</x>');

      return ast[0].children;
    }
  }),
  methods: {
    renderAST: function renderAST(h, ast) {
      var _this = this;

      var nestInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { quote: 1, sub: 1, isBlock: false };

      return ast.map(function (node) {
        if (node.type === 'text') {
          return Object(__WEBPACK_IMPORTED_MODULE_6_entities_lib_decode__["decodeHTML"])(node.content);
        }
        switch (node.name) {
          case 'blockquote':
            {
              var newNestInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nestInfo, {
                quote: nestInfo.quote + 1
              });
              return h('quote', {
                props: {
                  level: nestInfo.quote,
                  isDeep: nestInfo.quote === 4
                }
              }, _this.renderAST(h, node.children, newNestInfo));
            }
          case 'strong':
            return h('strong', _this.renderAST(h, node.children));
          case 'ins':
            return h('ins', _this.renderAST(h, node.children));
          case 'del':
            return h('del', _this.renderAST(h, node.children));
          case 'em':
            return h('em', _this.renderAST(h, node.children));
          case 'span':
            {
              return h('span', {
                style: getInlineStyle(node.attrs.style)
              }, _this.renderAST(h, node.children));
            }
          case 'div':
            return h('div', {
              style: getInlineStyle(node.attrs.style)
            }, _this.renderAST(h, node.children));
          case 'sub':
            {
              var _newNestInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nestInfo, {
                sub: nestInfo.sub + 1
              });
              return h('member', {
                props: {
                  level: nestInfo.sub,
                  isDeep: nestInfo.sub === 4
                }
              }, _this.renderAST(h, node.children, _newNestInfo));
            }
          case 'img':
            {
              var src = Object(__WEBPACK_IMPORTED_MODULE_6_entities_lib_decode__["decodeHTML"])(node.attrs.src);
              var noCache = 'data-no-cache' in node.attrs;
              var useProxy = _this.imageProxy && !noCache;

              if (node.attrs.class && node.attrs.class.indexOf('hkgmoji') >= 0) {
                return h('icon', {
                  props: { src: src }
                });
              }

              return h('pic', {
                props: {
                  src: useProxy ? 'https://i.lihkg.com/540/' + src : src,
                  original: src
                }
              });
            }
          case 'br':
            return h('br');
          case 'a':
            return h('anchor', {
              props: {
                href: Object(__WEBPACK_IMPORTED_MODULE_6_entities_lib_decode__["decodeHTML"])(node.attrs.href)
              }
            }, _this.renderAST(h, node.children));
          case 'pre':
            {
              var _newNestInfo2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nestInfo, {
                isBlock: true
              });
              return h('pre', _this.renderAST(h, node.children, _newNestInfo2));
            }
          case 'code':
            return h('code-block', {
              props: {
                isBlock: nestInfo.isBlock,
                language: node.attrs['data-type']
              }
            }, _this.renderAST(h, node.children));
          default:
            return null;
        }
      });
    }
  },
  render: function render(h) {
    return h('div', [this.renderAST(h, this.parsedMessage), this.$slots.link]);
  }
});

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['level', 'isDeep'],
  data: function data() {
    return {
      hideChildren: this.isDeep
    };
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['level', 'isDeep'],
  data: function data() {
    return {
      hideChildren: this.isDeep
    };
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_image_placeholder_png__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_image_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_image_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader__ = __webpack_require__(241);



//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['src', 'original'],
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_5__Loader__["a" /* default */]
  },
  data: function data() {
    return {
      placeholder: __WEBPACK_IMPORTED_MODULE_4__assets_image_placeholder_png___default.a,
      loaded: false,
      error: false,
      showImage: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    autoLoadImage: function autoLoadImage(state) {
      return state.app.autoLoadImage;
    },
    mediaList: function mediaList(state) {
      return state.thread.mediaList;
    },
    threadId: function threadId(state) {
      return state.thread.thread.thread_id;
    }
  }), {
    mediaIndex: function mediaIndex() {
      var _this = this;

      return this.mediaList ? this.mediaList.findIndex(function (media) {
        return media.url === _this.original;
      }) : -1;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchMediaList']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    setMediaIndex: 'SET_MEDIA_INDEX'
  }), {
    handleImageClick: function handleImageClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.mediaIndex === -1)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this2.fetchMediaList({ threadId: _this2.threadId });

              case 3:
                _this2.setMediaIndex(_this2.mediaIndex);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    loadImage: function loadImage() {
      this.showImage = true;
    },
    onLoad: function onLoad() {
      this.loaded = true;
    },
    onError: function onError() {
      this.error = true;
    }
  })
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3e808_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(669)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5db3e808"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3e808_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db3e808_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['f5']
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['src'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    flattenIconMap: function flattenIconMap(state) {
      return state.app.flattenIconMap;
    },
    officeMode: function officeMode(state) {
      return state.app.officeMode;
    },
    staticIcons: function staticIcons(state) {
      return state.app.staticIcons;
    }
  }), {
    source: function source() {
      return this.staticIcons ? this.src.replace('/faces/', '/faces_png/').replace('.gif', '.png') : this.src;
    },
    code: function code() {
      var uri = this.src.split('lihkg.com/')[1];
      return this.flattenIconMap[uri];
    }
  })
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YoutubePlayer__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LIHKGPreview__ = __webpack_require__(679);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['href'],
  components: {
    YoutubePlayer: __WEBPACK_IMPORTED_MODULE_3__YoutubePlayer__["a" /* default */],
    LIHKGPreview: __WEBPACK_IMPORTED_MODULE_4__LIHKGPreview__["a" /* default */]
  },
  data: function data() {
    return {
      isYoutube: false,
      isLihkg: false,
      linkInfo: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    youtubePreview: function youtubePreview(state) {
      return state.app.youtubePreview;
    }
  })),
  beforeMount: function beforeMount() {
    var ytMatches = this.href.match(__WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].ytRegex);
    var isYoutube = ytMatches && ytMatches[1];
    this.isYoutube = isYoutube;
    if (isYoutube) {
      var videoId = ytMatches && ytMatches[1];
      var start = ytMatches && ytMatches[2] ? __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].parseDuration(ytMatches[2].toLowerCase()) : 0;
      this.linkInfo = { videoId: videoId, start: start };
      return;
    }

    var lihkgMatches = this.href.match(__WEBPACK_IMPORTED_MODULE_2__helper__["a" /* default */].lihkgRegex);
    var isLihkg = lihkgMatches && lihkgMatches[1];
    this.isLihkg = isLihkg;
    if (isLihkg) {
      var threadId = lihkgMatches && lihkgMatches[1];
      this.linkInfo = { threadId: threadId };
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['videoId', 'start'],
  data: function data() {
    return {
      isReady: false
    };
  },

  methods: {
    playVideo: function playVideo() {
      var _this = this;

      this.player = new window.YT.Player(this.$refs.iframe, {
        height: '390',
        width: '640',
        videoId: this.videoId,
        startSeconds: this.start,
        playerVars: {
          rel: 0
        },
        events: {
          onReady: function onReady(event) {
            _this.isReady = true;
            event.target.playVideo();
          }
        }
      });
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__helper__["a" /* default */].initYoutube();
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(99);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['threadId', 'href'],
  data: function data() {
    return {
      isLoading: false,
      title: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.isLoading = true;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].fetchThread({ threadId: _this.threadId });

            case 4:
              _ref = _context.sent;
              response = _ref.response;

              _this.title = response.title;
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              console.log(error);

            case 12:
              _context.prev = 12;

              _this.isLoading = false;
              return _context.finish(12);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9, 12, 15]]);
    }))();
  }
});

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js__);
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.configure({ languages: [] });
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('apache', __webpack_require__(690));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('xml', __webpack_require__(691));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('bash', __webpack_require__(692));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('coffeescript', __webpack_require__(693));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('css', __webpack_require__(694));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('cs', __webpack_require__(695));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('cpp', __webpack_require__(696));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('markdown', __webpack_require__(697));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('dart', __webpack_require__(698));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('django', __webpack_require__(699));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('dockerfile', __webpack_require__(700));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('ruby', __webpack_require__(701));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('go', __webpack_require__(702));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('gradle', __webpack_require__(703));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('java', __webpack_require__(704));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('javascript', __webpack_require__(705));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('json', __webpack_require__(706));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('kotlin', __webpack_require__(707));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('less', __webpack_require__(708));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('matlab', __webpack_require__(709));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('nginx', __webpack_require__(710));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('objectivec', __webpack_require__(711));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('php', __webpack_require__(712));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('python', __webpack_require__(713));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('rust', __webpack_require__(714));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('scala', __webpack_require__(715));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('scss', __webpack_require__(716));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('sql', __webpack_require__(717));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('swift', __webpack_require__(718));
__WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.registerLanguage('yaml', __webpack_require__(719));

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['is-block', 'language'],
  mounted: function mounted() {
    if (this.isBlock && this.language) {
      try {
        var result = __WEBPACK_IMPORTED_MODULE_0_highlight_js_lib_highlight_js___default.a.highlight(this.language, this.$refs.block.textContent);
        this.$refs.block.innerHTML = result.value;
      } catch (err) {
        // unknown language
        // console.log(err)
      }
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['threadId', 'page', 'totalPage'],
  computed: {
    hasNextPage: function hasNextPage() {
      return this.page < this.totalPage;
    },
    hasPrevPage: function hasPrevPage() {
      return this.page > 1;
    }
  },
  methods: {
    switchPage: function switchPage(event) {
      this.$emit('navigate', event.target.value);
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ThreadList_ThreadList__ = __webpack_require__(211);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ThreadList: __WEBPACK_IMPORTED_MODULE_2__components_ThreadList_ThreadList__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: this.officeMode ? 'Google' : '名已留'
    };
  },
  data: function data() {
    return {
      canLoadMore: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    officeMode: function officeMode(state) {
      return state.app.officeMode;
    },
    threadList: function threadList(state) {
      return state.threadList.threadList;
    },
    threadListType: function threadListType(state) {
      return state.threadList.threadListType;
    },
    page: function page(state) {
      return state.threadList.page;
    },
    isLoading: function isLoading(state) {
      return state.threadList.isLoading;
    },
    activeThreadId: function activeThreadId(state) {
      return state.thread.thread.thread_id;
    },
    bookmarks: function bookmarks(state) {
      return state.app.bookmarks;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchThreadListByIds']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setCategory: 'SET_CATEGORY',
    setThreadList: 'SET_THREAD_LIST',
    setThreadListType: 'SET_THREAD_LIST_TYPE'
  }), {
    fetchAndScrollTop: function fetchAndScrollTop() {
      this.setThreadList([]);
      window.scrollTo(0, 0);
      this.fetchThreadListByIds({ threadIds: this.bookmarks });
    },
    handleLoadMore: function handleLoadMore() {
      if (this.canLoadMore) {
        this.fetchNextPage();
      }
    },
    fetchNextPage: function fetchNextPage() {
      this.fetchThreadListByIds({ threadIds: this.bookmarks, page: this.page + 1 });
    }
  }),
  watch: {
    threadListType: function threadListType(newVal, oldVal) {
      if (oldVal !== newVal && newVal === 'bookmarks') {
        this.setCategory({});
        this.fetchAndScrollTop();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.setThreadListType('bookmarks');

    setTimeout(function () {
      _this.canLoadMore = true;
    }, 200);

    if (this.activeThreadId) {
      var threadItem = document.getElementById(this.activeThreadId);
      if (threadItem) {
        threadItem.classList.add('highlight');
        setTimeout(function () {
          threadItem.classList.remove('highlight');
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intersection_observer__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_lazyload__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_observe_visibility__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_normalize_css_normalize_css__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nprogress_nprogress_css__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_mutation_types__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_font_css__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_font_css__);







var fetchIconMap = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
    var response, hkgmoji, flattenIconMap;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch('https://x.lihkg.com/hkgmoji2.json');

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            hkgmoji = _context.sent;
            flattenIconMap = hkgmoji.reduce(function (set, current) {
              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, set, current.icons.reduce(function (all, icon) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, all, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, icon[1], icon[0]));
              }, {}));
            }, {});
            return _context.abrupt('return', flattenIconMap);

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchIconMap() {
    return _ref2.apply(this, arguments);
  };
}();

var fetchSystemProperty = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var _ref4, response;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_19__api__["a" /* default */].fetchSystemProperty();

          case 2:
            _ref4 = _context2.sent;
            response = _ref4.response;
            return _context2.abrupt('return', response);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchSystemProperty() {
    return _ref3.apply(this, arguments);
  };
}();

var init = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
    var _ref6, _ref7, iconMap, systemProperty, fixedCategoryList;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([fetchIconMap(), fetchSystemProperty()]);

          case 2:
            _ref6 = _context3.sent;
            _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);
            iconMap = _ref7[0];
            systemProperty = _ref7[1];


            // remove 自選台
            fixedCategoryList = systemProperty.fixed_category_list;

            fixedCategoryList[0].cat_list = fixedCategoryList[0].cat_list.filter(function (cat) {
              return +cat.cat_id !== 999;
            });

            __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('SET_ICON_MAP', iconMap);
            __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('SET_CATEGORY_LIST', systemProperty.category_list);
            __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('SET_FIXED_CATEGORY_LIST', fixedCategoryList);

          case 11:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function init() {
    return _ref5.apply(this, arguments);
  };
}();



















__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_lazyload___default.a, {
  lazyComponent: true
});
__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_observe_visibility__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].directive('username', function (el, _ref) {
  var user = _ref.value;

  if (+user.level === 999) {
    el.className += ' color-admin';
  } else if (user.gender === 'M') {
    el.className += ' color-male';
  } else {
    el.className += ' color-female';
  }
});

window.addEventListener('storage', function (event) {
  if (event.key === 'history') {
    __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_15__store_mutation_types__["B" /* SYNC_HISTORY */], JSON.parse(event.newValue));
  }
  if (event.key === 'officeMode' || event.key === 'staticIcons' || event.key === 'autoLoadImage' || event.key === 'nightMode') {
    __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_15__store_mutation_types__["C" /* SYNC_SETTINGS */], {
      key: event.key,
      value: JSON.parse(event.newValue)
    });
  }
});

__WEBPACK_IMPORTED_MODULE_14__helper__["a" /* default */].initYoutube();

init();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_16__App__["a" /* default */]);
  }
});

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */,
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4f766f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(508)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4f766f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4f766f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6bf30_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(510)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60b6bf30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6bf30_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b6bf30_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopAppBar_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e47b13e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopAppBar_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  this["$style"] = __webpack_require__(512)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopAppBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e47b13e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopAppBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e47b13e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopAppBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appBar":"appBar_1Z7VPewz"};

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"appBar",class:_vm.$style.appBar,style:({ top: (_vm.top + "px"), zIndex: _vm.zIndex })},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopAppBar',{attrs:{"z-index":3,"disabled":!_vm.isMobile}},[_c('div',{staticClass:"navbar",class:{'has-menu': _vm.showDrawer}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"left",class:{'in-thread': _vm.inThreadView && !_vm.isMobile}},[(!_vm.isMobile)?_c('button',{staticClass:"action",class:{'is-active': _vm.showDrawer},on:{"click":_vm.handleNavMenuClick}},[_c('span',{class:_vm.showDrawer ? 'icon-x' : 'icon-menu'})]):_vm._e(),_vm._v(" "),(_vm.inThreadView)?[(_vm.inThreadView)?_c('button',{staticClass:"action",on:{"click":_vm.handleBackClick}},[_c('span',{staticClass:"icon-arrow-left"})]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"center"},[_c('div',{on:{"click":_vm.scrollToTop}},[(_vm.inThreadView)?_c('span',{attrs:{"title":_vm.thread.title}},[_vm._v(_vm._s(_vm.thread.title || 'LIHKG'))]):_c('span',[_vm._v(_vm._s(_vm.threadListTitle))])])]),_vm._v(" "),_c('div',{staticClass:"right"},[(!_vm.inThreadView && !_vm.isMobile)?[_c('a',{staticClass:"action",attrs:{"href":"https://github.com/colloquet/lihkg-web","target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"icon-github"})]),_vm._v(" "),_c('button',{staticClass:"action",attrs:{"title":"F5"},on:{"click":_vm.handleReloadClick}},[_c('span',{staticClass:"icon-refresh-ccw"})])]:_vm._e(),_vm._v(" "),(_vm.inThreadView && !_vm.isMobile)?[(!_vm.isMobile)?_c('button',{staticClass:"action bookmark",class:{ 'is-active': _vm.isBookmarked },attrs:{"title":"本地留名"},on:{"click":_vm.handleBookmark}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24","fill":_vm.isBookmarked ? '#f6b701' : 'none',"stroke":_vm.isBookmarked ? '#f6b701' : 'currentColor',"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item score"},[_c('span',{staticClass:"icon-thumbs-up"}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.thread.like_count || '-'))])]),_vm._v(" "),_c('div',{staticClass:"item score"},[_c('span',{staticClass:"icon-thumbs-down"}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.thread.dislike_count || '-'))])]),_vm._v(" "),(!_vm.isMobile)?_c('button',{staticClass:"action",attrs:{"title":"圖片模式"},on:{"click":_vm.handleMediaModeClick}},[_c('span',{staticClass:"icon-image"})]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('button',{staticClass:"action",class:{'is-active': _vm.$route.query.order === 'score'},attrs:{"title":"熱門回覆"},on:{"click":_vm.handleHotReplyClick}},[_c('span',{staticClass:"icon-trending-up"})]):_vm._e()]:_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('button',{staticClass:"action",attrs:{"title":"設定"},on:{"click":_vm.handleSettingsClick}},[_c('span',{staticClass:"icon-settings"})]):_vm._e()],2)])])])])}
var staticRenderFns = []


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomBar_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6453b316_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomBar_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(516)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6453b316"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6453b316_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6453b316_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-bar"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",on:{"click":_vm.handleDrawerClick}},[_c('span',{staticClass:"icon-menu"})])]),_vm._v(" "),(_vm.inThreadView)?[_c('div',{staticClass:"item score"},[_c('span',{staticClass:"icon-thumbs-up"}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.thread.like_count || '-'))])]),_vm._v(" "),_c('div',{staticClass:"item score"},[_c('span',{staticClass:"icon-thumbs-down"}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.thread.dislike_count || '-'))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",on:{"click":_vm.handleMediaModeClick}},[_c('span',{staticClass:"icon-image"})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",class:{'is-active': _vm.$route.query.order === 'score'},on:{"click":_vm.handleHotReplyClick}},[_c('span',{staticClass:"icon-trending-up"})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",class:{ 'is-active': _vm.isBookmarked },attrs:{"title":"本地留名"},on:{"click":_vm.handleBookmark}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24","fill":_vm.isBookmarked ? '#f6b701' : 'none',"stroke":_vm.isBookmarked ? '#f6b701' : 'currentColor',"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"}})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",on:{"click":_vm.handleScrollBottom}},[_c('span',{staticClass:"icon-chevrons-down"})])])]:[_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",on:{"click":_vm.handleReloadClick}},[_c('span',{staticClass:"icon-refresh-ccw"})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('button',{staticClass:"action",on:{"click":_vm.handleSettingsClick}},[_c('span',{staticClass:"icon-settings"})])])]],2)])}
var staticRenderFns = []


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee507c84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(519)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee507c84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee507c84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee507c84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{'is-open': _vm.isOpen}},[_c('div',{staticClass:"overlay",class:{'is-pressed': _vm.isPressed},style:(("opacity: " + _vm.opacity)),on:{"click":_vm.hideDrawer}}),_vm._v(" "),_c('div',{ref:"drawer",staticClass:"drawer",class:{'is-pressed': _vm.isPressed},style:(("transform: translate3d(" + _vm.xPos + "px, 0, 0);"))},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"brand"},[_vm._v("\n        LIHKG\n      ")]),_vm._v(" "),_c('button',{staticClass:"action",on:{"click":_vm.handleSettingsClick}},[_c('span',{staticClass:"icon-settings"})])]),_vm._v(" "),_c('div',{staticClass:"navigations"},[_c('a',{staticClass:"nav-item",class:{'is-active': _vm.threadListType === 'bookmarks'},attrs:{"href":"/bookmarks"},on:{"click":function($event){$event.preventDefault();return _vm.handleLinkClick($event)}}},[_vm._v("\n        名已留\n      ")])]),_vm._v(" "),_vm._l((_vm.fixedCategoryList),function(section){return _c('div',{key:section.name,staticClass:"section"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(section.name || '一般'))]),_vm._v(" "),_c('ul',{staticClass:"submenu"},_vm._l((section.cat_list),function(category){return _c('li',{key:category.cat_id},[_c('a',{staticClass:"nav-item",class:{'is-active': category.cat_id === _vm.activeCategoryId},attrs:{"href":("/category/" + (category.cat_id))},on:{"click":function($event){$event.preventDefault();return _vm.handleLinkClick($event)}}},[_vm._v("\n            "+_vm._s(category.name)+"\n          ")])])}),0)])})],2)])}
var staticRenderFns = []


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryMenu_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207b33e7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryMenu_vue__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(522)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-207b33e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207b33e7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryMenu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_207b33e7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryMenu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","duration":450}},[(_vm.showDrawer)?_c('div',[_c('div',{staticClass:"overlay",on:{"click":_vm.hideDrawer}}),_vm._v(" "),_c('div',{ref:"menu",staticClass:"menu"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navigations"},[_c('a',{staticClass:"nav-item",class:{'is-active': _vm.threadListType === 'bookmarks'},attrs:{"href":"/bookmarks"},on:{"click":function($event){$event.preventDefault();return _vm.handleLinkClick($event)}}},[_vm._v("\n            名已留\n          ")])]),_vm._v(" "),_c('div',{staticClass:"grid"},_vm._l((_vm.fixedCategoryList),function(section){return _c('div',{key:section.name,staticClass:"grid-item",class:{'is-single': section.name === '其他'}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(section.name || '一般'))]),_vm._v(" "),_c('ul',{staticClass:"submenu"},_vm._l((section.cat_list),function(category){return _c('li',{key:category.cat_id},[_c('a',{staticClass:"nav-item",class:{'is-active': category.cat_id === _vm.activeCategoryId},attrs:{"href":("/category/" + (category.cat_id))},on:{"click":function($event){$event.preventDefault();return _vm.handleLinkClick($event)}}},[_vm._v("\n                  "+_vm._s(category.name)+"\n                ")])])}),0)])}),0)])])]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsModal_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae317b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsModal_vue__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(525)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ae317b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae317b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae317b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515e7143_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(527)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515e7143_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515e7143_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","appear":""}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2)])])])])}
var staticRenderFns = []


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toggle_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e7ba28_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(530)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7e7ba28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e7ba28_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e7ba28_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toggle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"toggle",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.on},on:{"click":function($event){return _vm.$emit('change')}}}),_vm._v(" "),_c('label',{staticClass:"toggle-btn",attrs:{"data-tg-off":"關","data-tg-on":"開","for":_vm.id}})])}
var staticRenderFns = []


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButton_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3933d7e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(533)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3933d7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3933d7e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3933d7e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{ success: _vm.success },on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"top"},[_vm._t("text")],2),_vm._v(" "),_c('span',{staticClass:"bottom"},[_vm._t("successText")],2)])}
var staticRenderFns = []


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("設定")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('ul',{staticClass:"list"},[_c('li',[_vm._v("\n        夜間模式 "),_c('Toggle',{attrs:{"on":_vm.nightMode},on:{"change":function($event){return _vm.handleToggleClick('nightMode')}}})],1),_vm._v(" "),_c('li',[_vm._v("\n        自動載入圖片 "),_c('Toggle',{attrs:{"on":_vm.autoLoadImage},on:{"change":function($event){return _vm.handleToggleClick('autoLoadImage')}}})],1),_vm._v(" "),_c('li',[_vm._v("\n        節省圖片流量 "),_c('Toggle',{attrs:{"on":_vm.imageProxy},on:{"change":function($event){return _vm.handleToggleClick('imageProxy')}}})],1),_vm._v(" "),_c('li',[_vm._v("\n        Youtube 預覽 "),_c('Toggle',{attrs:{"on":_vm.youtubePreview},on:{"change":function($event){return _vm.handleToggleClick('youtubePreview')}}})],1),_vm._v(" "),_c('li',[_vm._v("\n        公司模式 "),_c('Toggle',{attrs:{"on":_vm.officeMode},on:{"change":function($event){return _vm.handleToggleClick('officeMode')}}})],1),_vm._v(" "),_c('li',[_vm._v("\n        靜態表情 "),_c('Toggle',{attrs:{"on":_vm.staticIcons},on:{"change":function($event){return _vm.handleToggleClick('staticIcons')}}})],1),_vm._v(" "),_c('li',{staticClass:"center"},[_c('ActionButton',{attrs:{"success":_vm.clearHistorySuccess},on:{"click":_vm.handleClearHistory}},[_c('span',{attrs:{"slot":"text"},slot:"text"},[_c('span',{staticClass:"icon-trash"}),_vm._v(" 清除瀏覽記錄\n          ")]),_vm._v(" "),_c('span',{attrs:{"slot":"successText"},slot:"successText"},[_vm._v("\n            成功！\n          ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('small',[_vm._v("Made in HK by "),_c('a',{attrs:{"href":"https://colloque.io/","target":"_blank"}},[_vm._v("Coke_Zero")])])])])])}
var staticRenderFns = []


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a30a7f66_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(537)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a30a7f66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a30a7f66_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a30a7f66_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Media_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ae03e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Media_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(539)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20ae03e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Media_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ae03e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Media_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ae03e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Media_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(this.src),expression:"this.src",arg:"background-image"}],staticClass:"container",on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"gallery"},on:{"before-enter":_vm.onBeforeEnter,"after-enter":_vm.onAfterEnter,"before-leave":_vm.onBeforeLeave}},[_c('div',{staticClass:"gallery",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleCloseClick($event)}}},[_c('nav',{staticClass:"nav"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"item"},[_c('span',{staticClass:"icon-image"}),_vm._v(" 媒體模式")]),_vm._v(" "),_c('button',{staticClass:"action",on:{"click":_vm.handleCloseClick}},[_c('span',{staticClass:"icon-x"})])])])]),_vm._v(" "),_c('div',{ref:"body",staticClass:"body",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleCloseClick($event)}}},[_c('div',{staticClass:"container",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleCloseClick($event)}}},[_c('div',{staticClass:"grid",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleCloseClick($event)}}},_vm._l((_vm.mediaList),function(media,index){return _c('div',{key:media.url,staticClass:"grid-item"},[_c('Media',{attrs:{"media":media},on:{"click":function($event){return _vm.handleMediaClick(index)}}})],1)}),0)])])])])}
var staticRenderFns = []


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lightbox_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad4bef2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(543)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ad4bef2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad4bef2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad4bef2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lightbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"lightbox","appear":""}},[_c('div',{staticClass:"lightbox",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleCloseClick($event)}}},[_c('button',{staticClass:"action close",on:{"click":_vm.handleCloseClick}},[_c('span',{staticClass:"icon-x"})]),_vm._v(" "),(_vm.hasPrev)?_c('button',{staticClass:"action prev",on:{"click":function($event){return _vm.handleNavigation(-1)}}},[_c('span',{staticClass:"icon-chevron-left"})]):_vm._e(),_vm._v(" "),(_vm.hasNext)?_c('button',{staticClass:"action next",on:{"click":function($event){return _vm.handleNavigation(1)}}},[_c('span',{staticClass:"icon-chevron-right"})]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('a',{key:_vm.media.url,staticClass:"image-link",class:{'is-loaded': _vm.imageLoaded, 'is-error': _vm.imageError},attrs:{"href":_vm.media.url,"target":"_blank"}},[(_vm.imageError)?_c('div',{staticClass:"error"}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":_vm.media.url,"alt":_vm.media.url},on:{"load":function($event){_vm.imageLoaded = true},"error":function($event){_vm.imageError = true}}})])])],1)])}
var staticRenderFns = []


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_vm._v(" "),_c('div',{staticClass:"route-container",attrs:{"id":"route-container"}},[_c('router-view')],1),_vm._v(" "),(_vm.isMobile)?_c('BottomBar'):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('Drawer'):_c('CategoryMenu'),_vm._v(" "),(_vm.showGallery)?_c('Gallery',{attrs:{"media-list":_vm.mediaList}}):_vm._e(),_vm._v(" "),(_vm.mediaIndex !== null)?_c('Lightbox',{attrs:{"media-index":_vm.mediaIndex}}):_vm._e(),_vm._v(" "),(_vm.showSettingsModal)?_c('SettingsModal',{on:{"close":_vm.toggleSettingsModal}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_CategoryView__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_ThreadView__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_BookmarksView__ = __webpack_require__(734);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (from.name === 'ThreadView' && to.name === 'ThreadView') {
      return false;
    }

    return { x: 0, y: 0 };
  },

  routes: [{ path: '/', redirect: '/category/1' }, { path: '/index.html', redirect: '/category/1' }, { path: '/thread/:threadId', redirect: '/thread/:threadId/page/1' }, { path: '/t/:threadId', redirect: '/thread/:threadId/page/1' }, { path: '/t/:threadId/page', redirect: '/thread/:threadId/page/:page' }, {
    path: '/category/:catId',
    name: 'CategoryView',
    component: __WEBPACK_IMPORTED_MODULE_2__views_CategoryView__["a" /* default */],
    props: true
  }, {
    path: '/thread/:threadId/page/:page',
    name: 'ThreadView',
    component: __WEBPACK_IMPORTED_MODULE_3__views_ThreadView__["a" /* default */],
    props: true
  }, {
    path: '/bookmarks',
    name: 'Bookmarks',
    component: __WEBPACK_IMPORTED_MODULE_4__views_BookmarksView__["a" /* default */]
  }]
});

router.afterEach(function (to) {
  if (window.ga) {
    window.ga('set', 'page', to.fullPath);
    window.ga('send', 'pageview');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 547 */,
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryView_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0d9e814_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryView_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(549)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0d9e814"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0d9e814_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryView_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0d9e814_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryView_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadListItem_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85517e88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(552)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85517e88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85517e88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85517e88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadListItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-tag"},[_vm._v("P")])}
var staticRenderFns = []


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('router-link',{staticClass:"thread-list-item",attrs:{"id":_vm.thread.thread_id,"to":_vm.routeObj}},[(_vm.isBookmarked)?_c('svg',{staticClass:"top indicator",staticStyle:{"width":"12px","height":"12px","margin-left":"2px","margin-top":"1px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"}})]):(_vm.thread.is_hot)?_c('span',{staticClass:"icon-hot top indicator"}):_vm._e(),_vm._v(" "),(_vm.hasUnread)?_c('span',{staticClass:"unread indicator"}):(_vm.isVisited)?_c('span',{staticClass:"visited indicator"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body"},[_c('small',{staticClass:"meta"},[_c('div',{staticClass:"meta-left"},[_c('span',{directives:[{name:"username",rawName:"v-username",value:(_vm.thread.user),expression:"thread.user"}],staticClass:"name"},[_vm._v("\n            "+_vm._s(_vm.thread.user_nickname)+"\n          ")]),_vm._v(" "),(_vm.thread.user.is_newbie)?_c('PTag'):_vm._e(),_vm._v(" "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.lastReplyTime))]),_vm._v(" "),(!_vm.isMobile)?_c('span',{staticClass:"replies"},[_c('span',{staticClass:"icon-message-square"}),_vm._v("\n            "+_vm._s(_vm.thread.no_of_reply)+"\n            "),(_vm.hasUnread)?_c('span',{staticClass:"new-reply"},[_vm._v("\n              ( +"+_vm._s(_vm.newReply)+" )\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"score"},[(_vm.score > -1)?_c('span',{staticClass:"icon-thumbs-up"}):_c('span',{staticClass:"icon-thumbs-down"}),_vm._v("\n            "+_vm._s(_vm.score)+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"meta-right"},[_c('label',{staticClass:"page-switcher",on:{"click":function($event){$event.preventDefault();return _vm.handlePageSelectClick($event)}}},[_vm._v("\n            "+_vm._s(_vm.thread.total_page)+" 頁 "),_c('span',{staticClass:"icon-chevron-down"}),_vm._v(" "),_c('select',{staticClass:"hidden-select",on:{"change":_vm.handlePageSelect}},[_c('option',[_vm._v("選擇頁數")]),_vm._v(" "),_vm._l((_vm.thread.total_page),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v("第 "+_vm._s(n)+" 頁")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"lower"},[(!_vm.isMobile && +_vm.thread.total_page > 1)?_c('div',{staticClass:"lower-left"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.thread.title))]),_vm._v(" "),_vm._l((+_vm.thread.total_page),function(page){return [(page <= 6)?_c('router-link',{key:page,staticClass:"page-link",attrs:{"to":("/thread/" + (_vm.thread.thread_id) + "/page/" + page)}},[_vm._v(_vm._s(page))]):(page > 6 && page === _vm.thread.total_page - 2)?_c('span',{key:page,staticClass:"page-link",on:{"click":function($event){$event.preventDefault();return _vm.handlePageSelectClick($event)}}},[_vm._v("\n              ...\n              "),_c('select',{staticClass:"hidden-select",on:{"change":_vm.handlePageSelect}},[_c('option',[_vm._v("選擇頁數")]),_vm._v(" "),_vm._l((_vm.thread.total_page),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v("第 "+_vm._s(n)+" 頁")])})],2)]):(_vm.thread.total_page - page < 2)?_c('router-link',{key:page,staticClass:"page-link",attrs:{"to":("/thread/" + (_vm.thread.thread_id) + "/page/" + page)}},[_vm._v(_vm._s(page))]):_vm._e()]})],2):_c('div',{staticClass:"lower-left"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.thread.title))])]),_vm._v(" "),_c('small',{staticClass:"category-label"},[_vm._v("\n          "+_vm._s(_vm.thread.category.name)+"\n        ")])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afcc546_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Placeholder_vue__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(557)
}
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4afcc546"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afcc546_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Placeholder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afcc546_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Placeholder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"meta animated"}),_vm._v(" "),_c('div',{staticClass:"title animated"})])}]


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.isLoading && !_vm.threadList.length)?_c('div',_vm._l((_vm.numberOfPlaceholder),function(n){return _c('placeholder',{key:n})}),1):_c('ul',{staticClass:"thread-list"},_vm._l((_vm.threadList),function(thread){return _c('ThreadListItem',{key:thread.thread_id,attrs:{"thread":thread,"is-visited":thread.thread_id in _vm.history,"last-read-page":thread.thread_id in _vm.history && _vm.history[thread.thread_id].page,"last-read-post-id":thread.thread_id in _vm.history && _vm.history[thread.thread_id].postId,"new-reply":thread.thread_id in _vm.history && thread.no_of_reply - _vm.history[thread.thread_id].replies}})}),1),_vm._v(" "),(_vm.hasMore)?_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onEndReached),expression:"onEndReached"}]}):_vm._e(),_vm._v(" "),(_vm.hasMore)?_vm._l((2),function(n){return _c('Placeholder',{key:n})}):_c('div',{staticClass:"end-of-list"},[_c('span',[_vm._v("完")])])],2)}
var staticRenderFns = []


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubCategorySwitcher_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5e72048_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubCategorySwitcher_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(561)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5e72048"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubCategorySwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5e72048_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubCategorySwitcher_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5e72048_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubCategorySwitcher_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container"},[_c('ul',{staticClass:"tab"},[_vm._l((_vm.preparedList),function(item,index){return (index < _vm.visibleItemsCount)?_c('li',{key:item.sub_cat_id,ref:"items",refInFor:true,staticClass:"tab-item"},[_c('router-link',{staticClass:"tab-item-inner",attrs:{"to":{ query: item.query },"exact":""}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])],1):_vm._e()}),_vm._v(" "),(_vm.visibleItemsCount < _vm.list.length)?_c('li',{staticClass:"tab-item"},[_c('div',{staticClass:"tab-item-inner",class:{'is-active': _vm.activeSubCatHidden}},[_vm._v("\n        "+_vm._s(_vm.activeSubCatHidden ? _vm.activeSubCat.name : '更多')+" "),_c('span',{staticClass:"icon-chevron-down"}),_vm._v(" "),_c('select',{staticClass:"hidden-select",domProps:{"value":_vm.activeSubCat.sub_cat_id},on:{"change":_vm.handleSubCatChange}},[_c('option',[_vm._v("更多")]),_vm._v(" "),_vm._l((_vm.preparedList),function(item,index){return (index >= _vm.visibleItemsCount)?_c('option',{key:item.sub_cat_id,domProps:{"value":item.sub_cat_id}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")]):_vm._e()})],2)])]):_vm._e()],2)])}
var staticRenderFns = []


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categoryview-container"},[(_vm.subCategoryList.length > 1)?_c('SubCategorySwitcher',{attrs:{"list":_vm.subCategoryList}}):_vm._e(),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},[_vm._v("\n    由於之前 LIHKG 受到網絡攻擊，佢地已經改左個 API，加左好多防禦措施。所以第三方暫時係用唔到。"),_c('br'),_vm._v("\n    暫時都冇咩可以做到，希望第時佢會開放申請第三方 API key。\n  ")])}]


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadView_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369b4f02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadView_vue__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(637)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-369b4f02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369b4f02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadView_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369b4f02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadView_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9403861a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(639)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9403861a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9403861a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9403861a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eda849c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(641)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eda849c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eda849c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 659 */,
/* 660 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quote_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258d2f88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(662)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-258d2f88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258d2f88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_258d2f88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[(_vm.hideChildren)?_c('button',{staticClass:"button",on:{"click":function($event){_vm.hideChildren = false}}},[_vm._v("顯示更多")]):_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Member_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f555dfa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Member_vue__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Member_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f555dfa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Member_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f555dfa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Member_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub',[(_vm.hideChildren)?_c('button',{on:{"click":function($event){_vm.hideChildren = false}}},[_vm._v("顯示更多")]):_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pic_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497d240c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pic_vue__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(667)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-497d240c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497d240c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pic_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497d240c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pic_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAM1BMVEVgYGAAAABhYWFhYWFgYGBhYWFhYWFpaWlgYGBiY2JhYWFhYWFiYmJgYGBgYGBhYWFfX1/JWldvAAAAEXRSTlNNAFAKREdABy4hOxMaFzIoJCz2s5EAAAGXSURBVFjD7dfJboQwEEXRcpVHIIb//9oEG/eLZCHZ5UU2qQ2DuKcZFi2TeUZS9jQ4PidpHT15dMw8CjCzi/IbSA71qOESgPjkPDbt4tiAyPUEOTs0jrgWsQKpHtlzl8HZT1ubdAPiuGjBTEyIJXLyA9Tdy0zOxfUhSByXnemJXG6B0r21YR4I9i4T5XtzGsWcd5nJMxHtGmAnIvZUX+ZgkhJ+6vl8E4BsxEybfI7tBIDr2YoSyPxcnXUAntiJCtjpM/vfAMG3d2CD7iWmBlzKr2Ail4lGC5hjs3Y7zDyACcEYFYD5B5YB+VoDxNOXBkDPDGECQE8EYQZAD2EGQA9hBkAPYRZAD+EdCNvx2kPoAfRMx2sPoQfQN6HvIRzdXxt6goC+E/bQ3UHrIbz0Nbp8D9QeAvp+ymkA6CGgfx8A6CGgHwHQ41uhHwDQ47xlGgNC15dhpkFA0GuGXVjqie2OXjXOL/SlVffsKSPWAJnSGpBI3NL3EzJxBYhtyaO+ASy6dG8Ayz7lA2DhqchLv7z0XV98Ly//vwGoNxKtwZn6oQAAAABJRU5ErkJggg=="

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{f5: _vm.f5}},[_vm._v("Loading...")])}
var staticRenderFns = []


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lazy-component',{staticStyle:{"display":"inline-block","vertical-align":"bottom"}},[(_vm.autoLoadImage || _vm.showImage)?[_c('a',{staticClass:"link",attrs:{"href":_vm.original,"target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.handleImageClick($event)}}},[_c('img',{staticClass:"lazy",class:{loaded: _vm.loaded},attrs:{"src":this.src},on:{"load":_vm.onLoad,"error":_vm.onError}})]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error"}):(!_vm.loaded)?_c('Loader'):_vm._e()]:_c('img',{staticClass:"placeholder",attrs:{"src":_vm.placeholder},on:{"click":_vm.loadImage}})],2)}
var staticRenderFns = []


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b97ee51_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b97ee51_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b97ee51_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icon_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.officeMode)?_c('span',[_vm._v(_vm._s(_vm.code))]):_c('img',{attrs:{"src":_vm.source,"alt":_vm.code}})}
var staticRenderFns = []


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anchor_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d67d6f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anchor_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anchor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d67d6f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anchor_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d67d6f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Anchor_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YoutubePlayer_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2933b32e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YoutubePlayer_vue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(676)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YoutubePlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2933b32e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YoutubePlayer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2933b32e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YoutubePlayer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yt-outer"},[_c('div',{staticClass:"yt-inner",on:{"click":_vm.playVideo}},[(!_vm.isReady)?_c('img',{staticClass:"yt-play-button",attrs:{"src":__webpack_require__(678),"alt":"Play"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"yt-spacer",style:(_vm.isReady ? '' : ("background-image: url(" + (("https://img.youtube.com/vi/" + _vm.videoId + "/0.jpg")) + ")"))},[_c('div',{ref:"iframe",staticClass:"iframe"})])])])}
var staticRenderFns = []


/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LIHKGPreview_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d00bed2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LIHKGPreview_vue__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(680)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d00bed2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LIHKGPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d00bed2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LIHKGPreview_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d00bed2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LIHKGPreview_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"container",attrs:{"href":_vm.href,"target":"_blank"}},[_c('div',{staticClass:"inner"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[(_vm.isLoading)?_c('div',[_vm._v("載入中...")]):(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"link"},[_vm._v(_vm._s(_vm.href))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('span',{staticClass:"icon-link"})])}]


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isYoutube && _vm.youtubePreview)?_c('div',[_c('YoutubePlayer',{attrs:{"video-id":_vm.linkInfo.videoId,"start":_vm.linkInfo.start}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)],1):(_vm.isLihkg)?_c('LIHKGPreview',{attrs:{"thread-id":_vm.linkInfo.threadId,"href":_vm.href}}):_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodeBlock_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f25498_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeBlock_vue__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(688)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CodeBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f25498_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeBlock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f25498_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodeBlock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code',{ref:"block",class:{'inline-code': !_vm.isBlock}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[(this.quote.quote)?[(_vm.level === 3 && _vm.hideChildren)?_c('blockquote',[_c('button',{staticClass:"button",on:{"click":function($event){_vm.hideChildren = false}}},[_vm._v("顯示更多")])]):_c('PostQuote',{attrs:{"quote":this.quote.quote,"level":_vm.level + 1}})]:_vm._e(),_vm._v(" "),_c('Message',{attrs:{"html":this.quote.msg}},[_c('a',{staticClass:"link",attrs:{"slot":"link","href":_vm.link,"target":"_blank","title":"跳至回覆"},slot:"link"},[_c('span',{staticClass:"icon-link"})])])],2)}
var staticRenderFns = []


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{ref:"container",staticClass:"post",attrs:{"id":("post-" + (_vm.post.msg_num)),"data-id":_vm.post.msg_num,"data-page":_vm.post.page}},[_c('small',{staticClass:"meta"},[_c('span',{class:{'color-admin': _vm.isAuthor}},[_vm._v("#"+_vm._s(_vm.post.msg_num))]),_vm._v(" "),_c('span',{directives:[{name:"username",rawName:"v-username",value:(_vm.post.user),expression:"post.user"}],staticClass:"username"},[_vm._v(_vm._s(_vm.post.user_nickname))]),_vm._v(" "),(_vm.post.user.is_newbie)?_c('PTag'):_vm._e(),_vm._v(" "),(_vm.storyMode && +_vm.storyMode !== +_vm.userId)?_c('span',{staticClass:"temp-visible-toggle",on:{"click":function($event){_vm.tempVisible = !_vm.tempVisible}}},[_vm._v("\n      暫時"+_vm._s(_vm.tempVisible ? '隱藏' : '顯示')+"\n    ")]):_c('span',{staticClass:"reply-time",attrs:{"title":_vm.showAbsoluteTime ? _vm.replyTime.relative : _vm.replyTime.absolute},on:{"click":function($event){_vm.showAbsoluteTime = !_vm.showAbsoluteTime}}},[_vm._v(_vm._s(_vm.showAbsoluteTime ? _vm.replyTime.absolute : _vm.replyTime.relative))]),_vm._v(" "),_c('span',{class:("icon-eye" + (_vm.storyMode ? '-off' : '') + " story-mode-toggle"),attrs:{"title":"追估模式"},on:{"click":_vm.handleToggleStoryMode}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.storyMode || +_vm.storyMode === +_vm.userId || _vm.tempVisible),expression:"!storyMode || +storyMode === +userId || tempVisible"}],staticClass:"post-msg"},[(this.post.quote)?_c('PostQuote',{attrs:{"quote":this.post.quote,"level":1}}):_vm._e(),_vm._v(" "),_c('Message',{attrs:{"html":this.post.msg}})],1),_vm._v(" "),_c('small',{staticClass:"scores"},[_c('span',[_c('span',{staticClass:"icon-arrow-up"}),_vm._v(" "+_vm._s(_vm.likeCount)+"\n    ")]),_vm._v(" "),_c('span',[_c('span',{staticClass:"icon-arrow-down"}),_vm._v(" "+_vm._s(_vm.dislikeCount)+"\n    ")])])])}
var staticRenderFns = []


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":("page-" + _vm.pageNumber)}},[_c('ul',{staticClass:"post-list"},_vm._l((_vm.pageObj),function(post){return (+post.status === 1)?_c('Post',{key:post.post_id,attrs:{"post":post}}):_vm._e()}),1)])}
var staticRenderFns = []


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadNavigation_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d3a6a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadNavigation_vue__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(725)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreadNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d3a6a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadNavigation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d3a6a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreadNavigation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation"},[_c('div',{staticClass:"navigation-item"},[(_vm.hasPrevPage)?_c('a',{attrs:{"href":("/thread/" + _vm.threadId + "/page/" + (+_vm.page - 1))},on:{"click":function($event){$event.preventDefault();return _vm.$emit('navigate', _vm.page - 1, true)}}},[_c('span',{staticClass:"icon-chevron-up"}),_vm._v(" 上一頁\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"navigation-item"},[_c('span',[_vm._v("\n      第 "+_vm._s(_vm.page)+" 頁 "),_c('span',{staticClass:"icon-chevron-down"}),_vm._v(" "),_c('select',{staticClass:"hidden-select",domProps:{"value":_vm.page},on:{"change":_vm.switchPage}},_vm._l((_vm.totalPage),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v("第 "+_vm._s(n)+" 頁")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"navigation-item"},[(_vm.hasNextPage)?_c('a',{attrs:{"href":("/thread/" + _vm.threadId + "/page/" + (+_vm.page + 1))},on:{"click":function($event){$event.preventDefault();return _vm.$emit('navigate', _vm.page + 1)}}},[_vm._v("\n      下一頁 "),_c('span',{staticClass:"icon-chevron-down"})]):_vm._e()])])}
var staticRenderFns = []


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5149e9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationPlaceholder_vue__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(728)
}
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a5149e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5149e9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationPlaceholder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5149e9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationPlaceholder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page animated"})])}]


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290464e8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostPlaceholder_vue__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(731)
}
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290464e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290464e8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostPlaceholder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290464e8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostPlaceholder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"meta animated"}),_vm._v(" "),_c('div',{staticClass:"msg line-1 animated"}),_vm._v(" "),_c('div',{staticClass:"msg line-2 animated"}),_vm._v(" "),_c('div',{staticClass:"msg line-3 animated"})])}]


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thread.thread_id)?_c('div',{staticClass:"threadview-container"},[_vm._l((_vm.thread.pages),function(pageObj,pageNumber){return [_c('ThreadNavigation',{key:(pageNumber + "-header"),attrs:{"thread-id":_vm.thread.thread_id,"page":+pageNumber,"total-page":_vm.thread.total_page},on:{"navigate":_vm.fetchPage}}),_vm._v(" "),_c('Page',{key:pageNumber,attrs:{"page-obj":pageObj,"page-number":+pageNumber,"thread-id":_vm.thread.thread_id}}),_vm._v(" "),(_vm.loadedPages.indexOf(pageNumber) === _vm.loadedPages.length - 1)?_c('ThreadNavigation',{key:(pageNumber + "-footer"),attrs:{"thread-id":_vm.thread.thread_id,"page":+pageNumber,"total-page":_vm.thread.total_page},on:{"navigate":_vm.fetchPage}}):_vm._e()]}),_vm._v(" "),_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onEndReached),expression:"onEndReached"}]}),_vm._v(" "),_c('div',{staticClass:"f5-container"},[(_vm.isLoading)?_c('Loader',{attrs:{"f5":true}}):_c('button',{staticClass:"f5-button",on:{"click":_vm.handleReloadClick}},[_c('span',[_vm._v("F5")])])],1)],2):_c('div',{staticClass:"loader-container"},[_c('NavigationPlaceholder'),_vm._v(" "),_c('div',_vm._l((3),function(n){return _c('PostPlaceholder',{key:n})}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookmarksView_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4ac613_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookmarksView_vue__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookmarksView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4ac613_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookmarksView_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4ac613_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookmarksView_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categoryview-container"},[_c('ThreadList',{attrs:{"thread-list":_vm.threadList,"is-loading":_vm.isLoading},on:{"load-more":_vm.handleLoadMore}})],1)}
var staticRenderFns = []


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ui__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_category__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_thread__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_threadList__ = __webpack_require__(749);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    ui: __WEBPACK_IMPORTED_MODULE_4__modules_ui__["a" /* default */],
    category: __WEBPACK_IMPORTED_MODULE_5__modules_category__["a" /* default */],
    thread: __WEBPACK_IMPORTED_MODULE_6__modules_thread__["a" /* default */],
    threadList: __WEBPACK_IMPORTED_MODULE_7__modules_threadList__["a" /* default */]
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  strict: true
}));

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);


__WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.configure({ showSpinner: false });

/* harmony default export */ __webpack_exports__["a"] = ({
  handleError: function handleError(store, error) {
    console.log(error);
    alert(error.error_message || '遇到未知問題');
  },
  startProgress: function startProgress() {
    __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
  },
  stopProgress: function stopProgress() {
    __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
  }
});

/***/ }),
/* 738 */,
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(64);



var _mutations;




var initialState = {
  isHoverable: !window.matchMedia('(hover: none)').matches,
  isMobile: window.innerWidth < 768,
  nightMode: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('nightMode') !== false,
  officeMode: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('officeMode') || false,
  staticIcons: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('staticIcons') || false,
  autoLoadImage: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('autoLoadImage') !== false,
  youtubePreview: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('youtubePreview') !== false,
  imageProxy: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('imageProxy') !== false,
  history: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('history') || {},
  bookmarks: __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].get('bookmarks') || [],
  flattenIconMap: {}
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["B" /* SYNC_HISTORY */], function (state, history) {
  state.history = history;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* SYNC_SETTINGS */], function (state, _ref) {
  var key = _ref.key,
      value = _ref.value;

  state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_ICON_MAP */], function (state, flattenIconMap) {
  state.flattenIconMap = flattenIconMap;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* SET_HISTORY */], function (state, thread) {
  var history = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.history, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, thread.thread_id, {
    page: thread.page,
    replies: thread.no_of_reply
  }));
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set('history', history);
  state.history = history;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["H" /* UPDATE_HISTORY */], function (state, _ref2) {
  var threadId = _ref2.threadId,
      postId = _ref2.postId,
      page = _ref2.page;

  var history = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.history, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, threadId, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.history[threadId] || {}, {
    page: page,
    postId: postId
  })));
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set('history', history);
  state.history = history;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* CLEAR_HISTORY */], function (state) {
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set('history', {});
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set('bookmarks', []);
  state.history = {};
  state.bookmarks = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["F" /* TOGGLE_SETTINGS */], function (state, key) {
  var value = !state[key];
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set(key, value);
  state[key] = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* SET_IS_MOBILE */], function (state, status) {
  state.isMobile = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* SET_IS_HOVERABLE */], function (state, status) {
  state.isHoverable = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADD_BOOKMARK */], function (state, postId) {
  state.bookmarks.unshift(postId);
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set('bookmarks', state.bookmarks);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* REMOVE_BOOKMARK */], function (state, postId) {
  var index = state.bookmarks.indexOf(postId);
  if (index > -1) {
    state.bookmarks.splice(index, 1);
  }
  __WEBPACK_IMPORTED_MODULE_2__storage__["a" /* default */].set('bookmarks', state.bookmarks);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function MemoryStorage() {
  var structureLocalStorage = {};
  this.setItem = function (key, value) {
    structureLocalStorage[key] = value;
  };
  this.getItem = function (key) {
    if (typeof structureLocalStorage[key] !== 'undefined') {
      return structureLocalStorage[key];
    }
    return null;
  };
  this.removeItem = function (key) {
    return delete structureLocalStorage[key];
  };
  this.clear = function () {
    structureLocalStorage = {};
  };
}

function LocalStorage() {
  this.set = function (key, value) {
    window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
  };
  this.get = function (key) {
    try {
      return JSON.parse(window.localStorage.getItem(key));
    } catch (error) {
      var item = window.localStorage.getItem(key);
      window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      return item;
    }
  };
  this.remove = function (key) {
    return window.localStorage.removeItem(key);
  };
  this.clear = function () {
    return window.localStorage.clear();
  };
}

function getStorage() {
  var storageImpl = void 0;
  try {
    window.localStorage.setItem('_', '');
    window.localStorage.removeItem('_');
    storageImpl = new LocalStorage();
  } catch (e) {
    storageImpl = new MemoryStorage();
  }
  return storageImpl;
}

var storage = getStorage();

/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(64);


var _mutations;



var initialState = {
  showDrawer: false,
  showSettingsModal: false,
  showGallery: false
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["D" /* TOGGLE_DRAWER */], function (state) {
  state.showDrawer = !state.showDrawer;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* OPEN_DRAWER */], function (state) {
  state.showDrawer = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* HIDE_DRAWER */], function (state) {
  state.showDrawer = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["G" /* TOGGLE_SETTINGS_MODAL */], function (state) {
  state.showSettingsModal = !state.showSettingsModal;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["E" /* TOGGLE_GALLERY */], function (state) {
  state.showGallery = !state.showGallery;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* HIDE_GALLERY */], function (state) {
  state.showGallery = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(64);


var _mutations;



var initialState = {
  categoryList: [],
  fixedCategoryList: [],
  category: {}
};

var getters = {};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_CATEGORY_LIST */], function (state, categoryList) {
  state.categoryList = categoryList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_FIXED_CATEGORY_LIST */], function (state, fixedCategoryList) {
  state.fixedCategoryList = fixedCategoryList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_CATEGORY */], function (state, category) {
  state.category = category;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(64);







var _mutations;




var initialState = {
  isLoading: false,
  isFetchingMedia: false,
  thread: {},
  page: 1,
  storyMode: null,
  mediaList: null,
  mediaIndex: null
};

var getters = {
  loadedPages: function loadedPages(state) {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.thread.pages || {});
  },
  maxPage: function maxPage(state, _getters) {
    return Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(_getters.loadedPages));
  },
  minPage: function minPage(state, _getters) {
    return Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(_getters.loadedPages));
  },
  hasNextPage: function hasNextPage(state, _getters) {
    return _getters.maxPage < state.thread.total_page;
  }
};

var actions = {
  fetchThread: function fetchThread(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;
    var threadId = _ref2.threadId,
        _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page,
        _ref2$append = _ref2.append,
        append = _ref2$append === undefined ? false : _ref2$append,
        _ref2$order = _ref2.order,
        order = _ref2$order === undefined ? 'reply_time' : _ref2$order;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.isLoading) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', false);

            case 2:

              dispatch('startProgress');
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* SET_THREAD_IS_LOADING */], true);
              if (!append) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* SET_THREAD */], {});
              }
              _context.prev = 5;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].fetchThread({ threadId: threadId, page: page, order: order });

            case 8:
              data = _context.sent;

              if (append) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["b" /* APPEND_THREAD */], data.response);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* SET_THREAD */], data.response);
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["A" /* SET_THREAD_PAGE */], page);
              if (order === 'reply_time') {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* SET_HISTORY */], data.response);
              }
              return _context.abrupt('return', data);

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](5);

              dispatch('handleError', _context.t0);
              return _context.abrupt('return', false);

            case 19:
              _context.prev = 19;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* SET_THREAD_IS_LOADING */], false);
              dispatch('stopProgress');
              return _context.finish(19);

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 15, 19, 23]]);
    }))();
  },
  fetchMediaList: function fetchMediaList(_ref3, _ref4) {
    var _this2 = this;

    var state = _ref3.state,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    var threadId = _ref4.threadId,
        _ref4$openGallery = _ref4.openGallery,
        openGallery = _ref4$openGallery === undefined ? false : _ref4$openGallery,
        _ref4$showProgress = _ref4.showProgress,
        showProgress = _ref4$showProgress === undefined ? true : _ref4$showProgress;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!state.isFetchingMedia) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:

              if (showProgress) {
                dispatch('startProgress');
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["n" /* SET_IS_FETCHING_MEDIA */], true);
              _context2.prev = 4;
              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].fetchMediaList({ threadId: threadId });

            case 7:
              data = _context2.sent;

              if (data.response.images.length) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["r" /* SET_MEDIA_LIST */], data.response.images);
                if (openGallery) {
                  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["E" /* TOGGLE_GALLERY */]);
                }
              } else {
                alert('找不到媒體');
              }
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](4);

              dispatch('handleError', _context2.t0);

            case 14:
              _context2.prev = 14;

              if (showProgress) {
                dispatch('stopProgress');
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["n" /* SET_IS_FETCHING_MEDIA */], false);
              return _context2.finish(14);

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[4, 11, 14, 18]]);
    }))();
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["s" /* SET_STORY_MODE */], function (state, storyMode) {
  state.storyMode = storyMode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["u" /* SET_THREAD_IS_LOADING */], function (state, value) {
  state.isLoading = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["A" /* SET_THREAD_PAGE */], function (state, page) {
  state.page = page;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* SET_THREAD */], function (state, thread) {
  state.thread = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, thread, {
    pages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, thread.page, thread.item_data)
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["b" /* APPEND_THREAD */], function (state, thread) {
  state.thread = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, thread, {
    pages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.thread.pages || {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, thread.page, thread.item_data))
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["n" /* SET_IS_FETCHING_MEDIA */], function (state, value) {
  state.isFetchingMedia = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["r" /* SET_MEDIA_LIST */], function (state, mediaList) {
  state.mediaList = mediaList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["q" /* SET_MEDIA_INDEX */], function (state, index) {
  state.mediaIndex = index;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(64);






var _mutations;





var initialState = {
  threadList: [],
  page: 1,
  isLoading: false,
  hasMore: true,
  threadListType: ''
};

var getters = {};

var actions = {
  fetchThreadList: function fetchThreadList(_ref2, _ref) {
    var _this = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    var catId = _ref.catId,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 1 : _ref$page,
        query = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['catId', 'page']);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var append, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.isLoading) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              append = page > 1;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["x" /* SET_THREAD_LIST_IS_LOADING */], true);

              _context.prev = 4;
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].fetchThreadList(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ catId: catId, page: page }, query));

            case 7:
              data = _context.sent;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["i" /* SET_CATEGORY */], data.response.category);
              if (append) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["c" /* APPEND_THREAD_LIST */], data.response.items);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["v" /* SET_THREAD_LIST */], data.response.items);
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* SET_THREAD_LIST_PAGE */], page);
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["w" /* SET_THREAD_LIST_HAS_MORE */], true);
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](4);

              if (_context.t0.error_code === 100) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["w" /* SET_THREAD_LIST_HAS_MORE */], false);
              } else {
                dispatch('handleError', _context.t0);
              }

            case 17:
              _context.prev = 17;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["x" /* SET_THREAD_LIST_IS_LOADING */], false);
              return _context.finish(17);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 14, 17, 20]]);
    }))();
  },
  fetchThreadListByIds: function fetchThreadListByIds(_ref3, _ref4) {
    var _this2 = this;

    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;
    var threadIds = _ref4.threadIds,
        _ref4$page = _ref4.page,
        page = _ref4$page === undefined ? 1 : _ref4$page,
        _ref4$perPage = _ref4.perPage,
        perPage = _ref4$perPage === undefined ? 25 : _ref4$perPage;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var append, startIndex, endIndex, currentPageIds, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!state.isLoading) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              append = page > 1;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["x" /* SET_THREAD_LIST_IS_LOADING */], true);

              startIndex = (page - 1) * perPage;
              endIndex = startIndex + perPage;
              currentPageIds = threadIds.slice(startIndex, endIndex);
              _context2.prev = 7;
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].fetchThreadListByIds({ threadIds: currentPageIds });

            case 10:
              data = _context2.sent;

              if (append) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["c" /* APPEND_THREAD_LIST */], data.response.items);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["v" /* SET_THREAD_LIST */], data.response.items);
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* SET_THREAD_LIST_PAGE */], page);
              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["w" /* SET_THREAD_LIST_HAS_MORE */], true);
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2['catch'](7);

              if (_context2.t0.error_code === 100) {
                commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["w" /* SET_THREAD_LIST_HAS_MORE */], false);
              } else {
                dispatch('handleError', _context2.t0);
              }

            case 19:
              _context2.prev = 19;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["x" /* SET_THREAD_LIST_IS_LOADING */], false);
              return _context2.finish(19);

            case 22:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[7, 16, 19, 22]]);
    }))();
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["z" /* SET_THREAD_LIST_TYPE */], function (state, type) {
  state.threadListType = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["x" /* SET_THREAD_LIST_IS_LOADING */], function (state, isLoading) {
  state.isLoading = isLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* SET_THREAD_LIST_PAGE */], function (state, page) {
  state.page = page;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["w" /* SET_THREAD_LIST_HAS_MORE */], function (state, hasMore) {
  state.hasMore = hasMore;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["v" /* SET_THREAD_LIST */], function (state, threadList) {
  state.threadList = threadList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["c" /* APPEND_THREAD_LIST */], function (state, threadList) {
  state.threadList = __WEBPACK_IMPORTED_MODULE_6__helper__["a" /* default */].uniqBy(state.threadList.concat(threadList), 'thread_id');
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[252]);


// WEBPACK FOOTER //
// static/js/app.2b2899a23ad1d78f7cd9.js